<template>
  <div class="vld-parent">
    <loading :active="isLoading"
             :can-cancel="false"
             :is-full-page="fullPage"/>

    <menu-superior :link="'/'+this.$store.state.empresa_url + '/menu'" titulo="MEU PEDIDO"></menu-superior>
    <bloco>
      <titulo-destacado titulo="Resumo do seu pedido">
        <span v-if="!this.$store.state.pedido.itens.length > 0" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>

      <div class="tb itens text-bold cor-primaria-divider">
        <span class="tb-fill">ITENS</span>
        <span class="tb-fit">VALOR</span>
      </div>

      <div v-for="(item, index) in this.$store.state.pedido.itens" :key="index">

        <div class="tb itens lista cor-primaria-divider">
          <span class="tb-fill text-bold">
            {{ item.quantidade + "x " + item.nome }}
            <br>R$ {{ (item.valor * item.quantidade).toFixed(2) }}
          </span>
          <span class="tb-fit right">
            <div class="div-add-produto">
              <i v-if="item.quantidade > 1" @click="ChangeQtdItem(item, false)" class="material-icons md-18 text-bold btn-remove-prod">remove</i>
              <i v-if="item.quantidade === 1" @click="RemoverItem(item)" class="material-icons md-18 text-bold btn-delete-prod">delete_forever</i>
              <span class="text-qtd">{{ item.quantidade}}</span>
              <i @click="ChangeQtdItem(item, true)" :class="['material-icons', 'md-18', 'text-bold', item.adicionais.length > 0 ? 'btn-add-prod-disable' : 'btn-add-prod']" >add</i>             
            </div>
          </span>
        </div>

        <div v-if="$store.state.empresa.mostrar_categoria_wpp == 'S'">
          <div v-for="(categoria, index) in item.categorias" :key="index">
            <span class="tb itens lista cor-primaria-divider text-bold grey-text text-darken-2"
                  style="padding-left: 16px">{{ categoria.descricao }}</span>
            <div v-for="(adicional, index) in categoria.adicionais" :key="index"
                 class="tb itens lista cor-primaria-divider">
              <span class="tb-fill" style="padding-left: 16px">
                {{ (adicional.quantidade * item.quantidade) + "x " + adicional.nome }}
              </span>
              <span class="tb-fit right">
                R$ {{ (adicional.valor * adicional.quantidade * item.quantidade).toFixed(2) }}
                <span @click="RemoverAdicional(item, adicional)"
                      :class="'btn-small materialize-red' + (adicional.obrigatorio == 'S' ? ' disabled': '')">
                  <i class="material-icons md-18" style="font-weight: bold">close</i>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(adicional, index) in item.adicionais" :key="index" class="tb itens lista cor-primaria-divider">
            <span class="tb-fill" style="padding-left: 16px">
              {{ (adicional.quantidade * item.quantidade) + "x " + adicional.nome }}
            </span>
            <span class="tb-fit right">
              R$ {{ (adicional.valor * adicional.quantidade * item.quantidade).toFixed(2) }}
              <span @click="RemoverAdicional(item, adicional)"
                    :class="'btn-small materialize-red' + (adicional.obrigatorio == 'S' ? ' disabled': '')">
                <i class="material-icons md-18" style="font-weight: bold">close</i>
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="tb itens text-bold grey-text text-darken-4 cor-primaria-divider">
        <span class="tb-fill">TOTAL</span>
        <span class="tb-fit">R$ {{ this.$store.getters.pedidoSubtotal.toFixed(2) }}</span>
      </div>
    </bloco>

    <div class="content-e">
      <router-link :to="'/' + this.$store.state.empresa_url + '/menu'"
                   class="waves-effect waves-light btn-small btn-large cor-primaria-bg">Acrescentar mais itens
      </router-link>
      <!-- <router-link :to="'/' + this.$store.state.empresa_url + '/pedido-enviado'"
                    class="waves-effect waves-light btn-small btn-large cor-primaria-bg">pedido enviado
       </router-link> -->
    </div>

    <bloco v-if="this.$store.state.empresa.is_modulo_cupom_disponivel">
      <titulo-destacado :fundo="'white'" titulo="Cupom de Desconto?"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria"></titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field">
          <input oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                 @input="cupom_desconto_btn = true;cupom_desconto_mensagem = ''"
                 pattern="^[a-zA-Z0-9]+$"
                 id="cupom_desconto_campo"
                 autocomplete="off" type="text" class="validate"
                 placeholder="Código Ativação" maxlength="30" v-model="cupom_desconto">
        </div>
        <span style="font-size: 11px;font-weight: 700;">{{ cupom_desconto_mensagem }}</span>
        <div class="waves-effect waves-light btn-small btn-block"
             @click="AplicarDesconto"
             v-if="cupom_desconto.length > 2 && cupom_desconto_btn"
             :style="'height: 22.4px; line-height: 22.4px; font-size: 12px;background-color: '+this.$store.state.empresa.cor_primaria">
          Aplicar
        </div>
      </div>
    </bloco>

    <bloco v-if="this.$store.state.empresa.habilitar_entrega == 'S'">
      <titulo-destacado titulo="Como deseja receber o pedido?"></titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 10px" id="divEntregaOpcao">
          <label class="grey-text text-darken-4">
            <input name="envio" value="ENTREGA" type="radio" class="with-gap" v-model="forma_entrega"
                   @click="ResetValorFrete('ENTREGA')" :disabled="this.EntregaisDisabled" />
            <span>Entrega:
              {{
                this.$store.state.empresa.taxa_entrega > 0 ? this.taxa_entrega_v2 : this.$store.state.empresa.empresa_frete_detalhes
              }}
              <br>(Podendo haver cobrança de taxas)
              <p v-if="this.EntregaisDisabled" style="color: red; margin-top: -5px;">Valor mínimo R$ {{this.$store.state.empresa.valor_minimo_entrega.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</p>
            </span>
          </label>
        </div>

        <div v-if="this.$store.state.empresa.retirar_local == 'S'" class="col" style="padding-top: 10px">
          <label class="grey-text text-darken-4">
            <input name="envio" value="RETIRADA" type="radio" class="with-gap" v-model="forma_entrega"
                   @click="ResetValorFrete('RETIRADA')"/>
            <span>Retirada<br>(Verificar disponibilidade)</span>
          </label>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_entrega == 'ENTREGA'">
      <titulo-destacado titulo="Endereço de Entrega">
        <span v-if="!this.endereco_entrega_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>

      <div class="bloco-lista">
        <div v-for="endoff in enderecos_offline" :key="endoff.bairro_id" class="col" style="padding-top: 8px">
          <div class="row" v-if="endoff">
            <div class="col s10">
              <label class="grey-text text-darken-4">
                <input class="right with-gap" type="radio" :name="endoff" :value="endoff"
                       v-model="endereco_offiline_selecionado" @change="SelecionarEnderecoSalvo(endoff)"
                       style="display: inherit;"/>
                <!-- <input class="right with-gap" type="radio" :name="endoff" :value="endoff" v-model="endereco_offiline_selecionado" @click="LimparEndereco()" @change="CalcularFrete(endoff.bairro_nome)" style="display: inherit;" /> -->
                <!--                <input class="right with-gap" type="radio" :name="endoff" :value="endoff" v-model="endereco_offiline_selecionado" @click="CalcularFrete(endoff.bairro_nome)" @change="CalcularFrete(endoff.bairro_nome)" style="display: inherit;" />-->
                <!--                -->
                <span>
                  <strong>{{
                      endoff.endereco + (endoff.numero ? ', ' + endoff.numero : '') + (endoff.complemento ? ', ' + endoff.complemento : '')
                    }}</strong>, {{ endoff.bairro_nome }}, {{ endoff.cidade_nome }}/{{
                    endoff.uf
                  }}{{ endoff.cep ? ', CEP:' + endoff.cep : '' }}
                </span>
              </label>
            </div>
            <div class="col s2">
              <i class="material-icons md-30 materialize-red-text" @click="RemoverEndereco(endoff)">delete_forever</i>
            </div>
          </div>
        </div>
        <div class="content-e col" style="margin-top: 8px">
          <button class="waves-effect waves-light btn-small cor-primaria-bg" @click="NovoEndereco()">
            Novo Endereço
          </button>
        </div>
      </div>
      <hr>

      <div class="bloco-lista" v-if="novo_endereco">
        <!-- somenteBairro === 'S' || -->
        <div class="row" style="margin-bottom: 0px"
        v-if="(permitir_endereco_parcial === 'S' && this.$store.state.empresa.forma_cobranca_frete === 'FIXO')">
          <br>
          <!-- Switch -->
          <div class="switch">
            <label>
              Não Sei o Endereço
              <input type="checkbox" v-model="naoSeiEndereco">
              <span class="lever"></span>
            </label>
          </div>
        </div>

        <div class="row" style="margin-bottom: 0px" v-if="!naoSeiEndereco && !ocultarcep">
          <div class="input-field col s10" style="padding: 0 10px 0 0;">
            <input
              id="cep"
              placeholder="Digite seu CEP "
              v-model="endereco.cep"
              value=""
              type="number"
              required
              class="validate"
              style="left: 0px;" v-on:input="maxLengthCheck()" v-on:blur="PesquisarCep()">
            <label for="cep" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </div>
          <div class="col s2" style="padding: 24px 0 0 0;">
            <a @click="PesquisarCep()" class="waves-effect waves-light btn-small cor-primaria-bg"><i
              class="material-icons md-24">search</i></a>
          </div>
        </div>

        <div class="row" v-if="!naoSeiEndereco">
          <div :class="'input-field col ' + (!naoSeiEndereco ? 's8' : 's12')" style="padding: 0 0rem 0 0;">
            <input autocomplete="off" id="endereco" v-model="endereco.endereco" type="text" class="validate" required
                   style="left: 0px;" :placeholder="!naoSeiEndereco ? 'Endereço' : 'Informe o Departamento / Setor'"
                   maxlength="50" @blur="CalcularFreteDebounced('')">
            <label for="endereco" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </div>
          <div class="input-field col s4" style="padding: 0 0.70rem;" v-if="!naoSeiEndereco">
            <input autocomplete="off" id="s_numero" type="number" v-model="endereco.numero" class="validate"
                   placeholder="Número" @blur="CalcularFreteDebounced('')">
            <label for="s_numero" class="grey-text text-darken-4"></label>
          </div>
        </div>

        <div class="" style="margin-bottom: 0px" v-if="!naoSeiEndereco || somenteBairro === 'S' ">

          <div class="input-field col s12" v-if="somenteBairro === 'N'" style="padding: 0 0.00rem;">
            <input autocomplete="off" id="complemento" v-model="endereco.complemento" type="text" class="validate"
                   placeholder="Complemento ou Ponto de Referência" maxlength="150">
            <label for="complemento" class="grey-text text-darken-4"></label>
          </div>

          <!-- Sempre mostra o país, seja como select ou texto -->
          <div class="input-field col s12" style="padding: 0 0rem 0 0;">
            <template v-if="paisesDisponiveis.length > 1">
              <select autocomplete="off" class="browser-default" v-model="pais_selecionado" @change="onPaisChange"
                      style="margin-bottom: 10px;">
                <option value="" disabled selected>Selecione o País</option>
                <option v-for="pais in paisesDisponiveis" 
                        :key="pais.id" 
                        :value="pais.id">
                  {{ pais.nome }}
                </option>
              </select>
            </template>
            <template v-else-if="paisesDisponiveis.length === 1">
              <div class="browser-default" style="margin-bottom: 10px; padding: 8px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 2px;">
                {{ paisesDisponiveis[0].nome }}
              </div>
            </template>
          </div>

          <div class="input-field col s12" style="padding: 0 0rem 0 0;">
            <select autocomplete="off" v-if="this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO'"
                    class="browser-default" @change="CalcularFreteDebounced(bairro_id)" v-model="bairro_id"
                    style="color: red;font-weight: 700;" :disabled="!pais_selecionado">
              <option value="" disabled selected>
                {{ paisesDisponiveis.length > 1 && !pais_selecionado ? 'Selecione o país primeiro' : 'Selecione o Bairro' }}
              </option>
              <option v-for="bairro in bairrosFiltrados"
                      :key="bairro.bairro_id" 
                      :value="bairro.bairro_id">
                {{ bairro.bairro }} - {{ bairro.cidade }}/{{ bairro.uf }} (R$ {{ bairro.valor }})
              </option>
            </select>
            <span v-else>
            <input autocomplete="off" id="bairro" type="text" v-model="endereco.bairro" class="validate" required
                   style="left: 0px;" placeholder="* Digite aqui um Bairro" maxlength="50" @blur="CalcularFreteDebounced('')">
            <label for="bairro" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </span>

          </div>
        </div>

        <div class="row" v-if="naoSeiEndereco">
          <div :class="'input-field col ' + (!naoSeiEndereco ? 's8' : 's12')" style="padding: 0 0rem 0 0;">
            <input autocomplete="off" id="endereco" v-model="endereco.endereco" type="text" class="validate" required
                   style="left: 0px;" :placeholder="!naoSeiEndereco ? 'Endereço' : 'Informe o Departamento / Setor'"
                   maxlength="50" @blur="CalcularFreteDebounced('')">
            <label for="endereco" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </div>
          <div class="input-field col s4" style="padding: 0 0.70rem;" v-if="!naoSeiEndereco">
            <input autocomplete="off" id="s_numero" type="number" v-model="endereco.numero" class="validate"
                   placeholder="Número" @blur="CalcularFreteDebounced('')">
            <label for="s_numero" class="grey-text text-darken-4"></label>
          </div>
        </div>


        <div align="center"
             v-if="this.$store.state.empresa.forma_cobranca_frete != 'BAIRRO' && this.$store.state.empresa.forma_cobranca_frete != 'FIXO'">
          <button class="waves-effect waves-light btn-small cor-primaria-bg" @click="CalcularFreteDebounced('')">Confirmar
            Endereço
            <i class="material-icons right">check</i>
          </button>
        </div>

        <div class="row">
          <div class="input-field col s12" style="padding: 0 0rem 0 0;">
            <input autocomplete="on" id="cidade" v-model="endereco.cidade_nome" type="text" disabled
                   placeholder="Cidade" class="validate" style="left: 0px;" maxlength="50" @blur="CalcularFreteDebounced('')">
            <!--            <vue-google-autocomplete-->
            <!--              id="cidade"-->
            <!--              @blur="CalcularFrete('')"-->
            <!--              :country="['br']"-->
            <!--              types="(cities)"-->
            <!--              classname="form-control"-->
            <!--              v-on:placechanged="getAddressData"-->
            <!--              placeholder="Digite o nome da cidade"-->
            <!--            >-->
            <!--            </vue-google-autocomplete>-->
            <label for="cidade" class="grey-text text-darken-4"></label>
          </div>
          <div class="input-field col s12" style="padding: 0 0rem 0 0;">
            <select class="browser-default" v-model="endereco.uf" disabled autocomplete="off" id="estado">
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espirito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MT">Mato Grosso</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO" selected>Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
            </select>
          </div>

        </div>
      </div>
    </bloco>

    <bloco>
      <titulo-destacado titulo="Forma de Pagamento">
        <span v-if="!this.forma_pagamento" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_dinheiro == 'S'">
      <label class="grey-text text-darken-4">
        <input value="DINHEIRO" type="radio" class="with-gap" v-model="forma_pagamento"
               @click="CalcularDesconto($event, 'DINHEIRO')"/>
        <span>Dinheiro {{ ObservacaoPagamento('DINHEIRO') }}</span>
      </label>
      <a class="btn right" style="padding: 4px; margin: 1px"
         :class="{'cor-primaria-bg': !precisa_troco, 'cor-vermelho-bg': precisa_troco}"
         v-if="forma_pagamento == 'DINHEIRO'"
         @click="precisa_troco = !precisa_troco; CalcularDesconto($event, 'DINHEIRO');">
        {{ precisa_troco ? 'Não preciso de troco' : 'Preciso de troco' }}
      </a>
    </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_pix == 'S'">
          <label class="grey-text text-darken-4">
            <input value="PIX" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'PIX');"/>
            <span>PIX {{ObservacaoPagamento('PIX')}}</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_mercadopago_pix == 'S') && (this.$store.state.empresa.modulo_mercadopago_status == 'ATIVO')">
          <label class="grey-text text-darken-4">
            <input value="MERCADOPAGO_PIX" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'MERCADOPAGO_PIX');"/>
            <span>PIX Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_paghiper_pix == 'S') && (this.$store.state.empresa.modulo_paghiper_status == 'ATIVO')">
          <label class="grey-text text-darken-4">
            <input value="PAGHIPER_PIX" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'PAGHIPER_PIX');"/>
            <span>PIX Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_debito == 'S'">
          <label class="grey-text text-darken-4">
            <input value="DEBITO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'DEBITO');"/>
            <span>Maquininha de Débito {{ObservacaoPagamento('DEBITO')}}</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_credito == 'S'">
          <label class="grey-text text-darken-4">
            <input value="CREDITO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'CREDITO');"/>
            <span>Maquininha de Crédito {{ObservacaoPagamento('CREDITO')}}</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_mercadopago_cartao == 'S') && (this.$store.state.empresa.modulo_mercadopago_status == 'ATIVO')">
          <label class="grey-text text-darken-4">
            <input value="MERCADOPAGO_CARTAO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'MERCADOPAGO_CARTAO');"/>
            <span>Cartão Débito/Crédito Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_softexpress_cartao == 'S') && (this.$store.state.empresa.modulo_softexpress_status == 'ATIVO')">
          <label class="grey-text text-darken-4">
            <input value="SOFTEXPRESS_CARTAO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'SOFTEXPRESS_CARTAO');"/>
            <span>Cartão de Crédito Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_transferencia == 'S'">
          <label class="grey-text text-darken-4">
            <input value="TRANSFERENCIA" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'TRANSFERENCIA');"/>
            <span>Transferência {{ObservacaoPagamento('TRANSFERENCIA')}}</span>
          </label>         
        </div>
        <div class="col" style="padding-top: 10px"
             v-if="(this.$store.state.empresa.pagamento_mercadopagolink == 'S') && (this.$store.state.empresa.modulo_mercadopago_status == 'ATIVO')">
          <label class="grey-text text-darken-4">
            <input value="MERCADOPAGOLINK" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'MERCADOPAGOLINK');"/>
            <span>Pagamento com Link Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_vale_alimentacao == 'S'">
          <label class="grey-text text-darken-4">
            <input value="VALE_ALIMENTACAO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'VALE_ALIMENTACAO');"/>
            <span>Vale Alimentação {{ObservacaoPagamento('VALE_ALIMENTACAO')}}</span>
          </label>           
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_vale_refeicao == 'S'">
          <label class="grey-text text-darken-4">
            <input value="VALE_REFEICAO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'VALE_REFEICAO');"/>
            <span>Vale Refeição {{ObservacaoPagamento('VALE_REFEICAO')}}</span>
          </label>          
        </div>
      </div>
    </bloco>

    <bloco v-if="precisa_troco && this.$store.state.empresa.pagamento_dinheiro == 'S'">
      <titulo-destacado titulo="Troco para quanto?">
        <span v-if="!this.troco_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field col s8" style="padding: 0 0rem 0 0;">
          <money id="troco_valor" v-model="troco_para_quanto"></money>
          <label for="troco_valor" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'PIX'">
      <titulo-destacado titulo="Dados do PIX">
        <span v-if="!this.conta_bancaria" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 8px">
          <div class="row">
            <div class="col s12">
              <label class="grey-text text-darken-4">
                <span>
                  <strong>PIX - Tipo:</strong> &nbsp;&nbsp; {{ this.$store.state.empresa.pagamento_pix_chave_tipo }}
                  <span>
                    <br><br>
                    <strong>PIX - Chave Pagamento:</strong> <hr>
                    <input type="text" :value="this.$store.state.empresa.pagamento_pix_chave" id="myInput" readonly>
                    <button @click="myFunction()">Copiar</button>
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'TRANSFERENCIA' && this.contas.length > 0">

      <titulo-destacado titulo="Selecione uma conta">
        <span v-if="!this.conta_bancaria" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>

      <div class="bloco-lista">
        <div v-for="conta in this.contas" :key="conta.id" class="col" style="padding-top: 8px">
          <div class="row" v-if="conta.ativo == 'S'">
            <div class="col s12">
              <label class="grey-text text-darken-4">
                <input class="right with-gap" type="radio" :name="conta" :value="conta" v-model="conta_bancaria"
                       style="display: inherit;"/>
                <span>
                    <strong>{{ conta.banco.nome }} ({{ conta.banco.codigo }})</strong>
                    <br>
                     TIPO CONTA: &nbsp;&nbsp;{{ conta.tipo_conta }}

                    <span v-if="conta.informacoes_adicionais">
                       <br>
                     OBSERVAÇÕES: &nbsp;&nbsp;{{ conta.informacoes_adicionais }}
                     </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

    </bloco>

    <bloco v-if="this.forma_pagamento == 'VALE_ALIMENTACAO' && this.bandeiras_vale_alimentacao.length > 0">

      <titulo-destacado titulo="Selecione a bandeira">
        <span v-if="!this.bandeira_vale_alimentacao" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>

      <div class="bloco-lista">
        <div v-for="bandeira in this.bandeiras_vale_alimentacao" :key="'bandeira-' + bandeira.id" class="col"
             style="padding-top: 8px">
          <div class="col s12">
            <label class="grey-text text-darken-4">
              <input class="right with-gap" type="radio" :name="bandeira.descricao" :value="bandeira"
                     v-model="bandeira_vale_alimentacao"
                     style="display: inherit;"/>
              <span>
                    <strong>{{ bandeira.descricao }}</strong>
                </span>
            </label>
          </div>
        </div>
      </div>

    </bloco>

    <bloco v-if="this.forma_pagamento == 'VALE_REFEICAO' && this.bandeiras_vale_refeicao.length > 0">

      <titulo-destacado titulo="Selecione a bandeira">
        <span v-if="!this.bandeira_vale_refeicao" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>

      <div class="bloco-lista">
        <div v-for="bandeira in this.bandeiras_vale_refeicao" :key="'bandeira-vr-' + bandeira.id" class="col"
             style="padding-top: 8px">
          <div class="col s12">
            <label class="grey-text text-darken-4">
              <input class="right with-gap" type="radio" :name="bandeira.descricao" :value="bandeira"
                     v-model="bandeira_vale_refeicao"
                     style="display: inherit;"/>
              <span>
                    <strong>{{ bandeira.descricao }}</strong>
                </span>
            </label>
          </div>
        </div>
      </div>

    </bloco>


    <bloco v-if="this.$store.state.empresa.usa_agendamento == 'S'">
      <titulo-destacado titulo="Agendamento">
        <span v-if="!this.agendamento_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="margin-top: 12px">
          <div v-if="!this.agendamento_liberado" class="switch">
            <label class="grey-text text-darken-4" style="font-size: 1em">
              Agendamento
              <input type="checkbox" v-model="agendamento" disabled="true">
              <span class="lever"></span>
            </label>
          </div>
          <div v-else class="switch">
            <label class="grey-text text-darken-4" style="font-size: 1em">
              Agendar pedido?
              <input type="checkbox" v-model="agendamento">
              <span class="lever"></span>
            </label>
          </div>
        </div>
        <div class="row" v-show="this.agendamento" style="margin: 8px 0 0 0">
          <div class="col s12" style="padding: 0 8px 0 0; margin: 0">
            <label class="red-text text-darken-4" style="color: red;font-weight: bold">Selecione uma Data</label>
            <input @focusout="handleFocusout" class="validate datepicker" required v-model="data_agendamento"
                   type="text"
                   style="height: 38px; margin-left: 20px" placeholder="data agendamento">
            <span class="fa fa-calendar fa-1x errspan"></span>
          </div>
          <div class="col s12 cor-primaria-bg cor-primaria-border white-text"
               style="padding: 8px 8px 8px 8px; margin: 0;   ">
            <span style="font-weight: bold">Horários Disponiveis</span>
            <hr>
            <ul>
              <li
                style="margin-bottom: 0px;"
                v-for="horario in horariosSelecionados"
                :key="horario.dia"
                :class="
                  'horarios row' +
                  ($store.state.empresa.dia_semana == horario.dia
                    ? ' text-bold'
                    : '')
                "
              >
                <span class="col s3">{{ horario.descricao }}</span>
                <span class="col s9">{{
                    horario.horarios == "00:00 às 23:59" ? "Aberto 24 horas" : horario.horarios
                  }}</span>
              </li>

            </ul>
          </div>
          <div class="col s12" style="padding: 0 8px 0 0; margin: 0">
            <label class="red-text text-darken-4" style="color: red;font-weight: bold">Selecione um Horário</label>
            <input @focusout="handleFocusout" class="validate timepicker" :disabled="this.data_agendamento == ''"
                   required
                   v-model="hora_agendamento" type="text" style="height: 38px; margin-left: 20px" placeholder="horario">
            <span class="fa fa-clock fa-1x errspan"></span>
          </div>
        </div>
      </div>
    </bloco>

    <bloco>
      <titulo-destacado titulo="Informe os seus dados">
        <span v-if="!this.dados_pessoa_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field" style="padding: 0;">
          <input id="nome_cliente" class="validate" required v-model="nome_cliente" type="text" style="left: 0px;"
                 placeholder="Seu nome e sobrenome">
          <label for="nome_cliente" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
        </div>

        <div class="input-field" style="padding: 0;">
          <div class="row" style="margin-bottom: 0;">
            <div class="col s4" v-show="showPaisesCombobox" style="padding-left: 0;">
              <div v-if="codigoAreaCustom">
                <input type="text" v-model="pais_selecionado_obj.codigo_area" placeholder="(ex: +55)" 
                      @input="validarCodigoArea" class="browser-default" style="height: 43px; width: 100%;">
                <button type="button" @click="switchToPaisSelection" class="btn-small" style="margin-top: 5px; width: 100%;">Cancelar</button>
              </div>
              <div v-else>
                <select v-model="pais_selecionado_obj" class="browser-default" @change="handlePaisChange" style="height: 43px; width: 100%;">
                  <option v-for="pais in paisesTelefoneList" 
                          :key="pais.codigo_area" 
                          :value="pais">
                    {{ formatarPais(pais) }}
                  </option>
                  <option :value="{codigo_area: 'outros'}">Outros</option>
                </select>
              </div>
            </div>
            <div :class="{'col s8': showPaisesCombobox, 'col s12': !showPaisesCombobox}" style="padding-right: 0;">
              <input v-if="!paisesTelefoneList.length" 
                     id="telefone" 
                     v-model="telefone" 
                     type="tel" 
                     required
                     class="validate" 
                     placeholder="Seu Telefone..."/>
              <the-mask v-else-if="!codigoAreaCustom" 
                       id="telefone" 
                       v-model="telefone" 
                       type="tel" 
                       required 
                       :masked="true"
                       :mask="phoneMask" 
                       placeholder="Seu Telefone..."/>
              <input v-else 
                     id="telefone" 
                     v-model="telefone" 
                     type="tel" 
                     required 
                     class="validate" 
                     placeholder="Seu Telefone..."/>
              <label for="telefone" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
            </div>
          </div>
        </div>

        <!-- CPF section -->
        <div class="row" style="margin-bottom: 0;">
          <div class="col s12" v-if="this.$store.state.empresa.perguntar_cpf_nota == 'S'">
            <div class="switch">
              <label class="grey-text text-darken-4">
                CPF na nota?
                <input type="checkbox" v-model="cpf_nota">
                <span class="lever"></span>
              </label>
            </div>
          </div>
        </div>

        <!-- CPF Input Field -->
        <div class="row" v-if="cpf_nota">
          <div class="input-field col s12 m10 l8" style="padding: 0px 0rem 0px 0px;">
            <input
              v-mask="'###.###.###-##'"
              type="text"
              id="cpf"
              v-model="cpf"
              required
              class="validate"
              placeholder="Seu CPF...">
            <label for="cpf" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem;"></label>
          </div>
        </div>

        <div v-if="this.$store.state.empresa.usar_bot_conversa == 'S'">
          <div class="col">
            <div class="switch">
              <label class="grey-text text-darken-4" style="display: flex; align-items: center;">
                <i 
                  class="material-icons" 
                  :style="{ color: receber_promocao ? '#4CAF50' : '#BDBDBD' }" 
                  style="margin-right: 8px;"
                >
                  check_circle
                </i>
                Ao continuar você concorda com o envio de promoções via WhatsApp?
                <input type="checkbox" v-model="receber_promocao">
                <span class="lever"></span>
              </label>
            </div>
          </div>
        </div>      

      </div>
    </bloco>

    <bloco v-if="this.$store.state.empresa.observacoes_pedido == 'S'">
      <div class="input-field" style="padding: 0 0rem 0 0;">
        <titulo-destacado v-bind:titulo="this.$store.state.empresa.label_observacoes">
          <span v-if="!this.agendamento_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        </titulo-destacado>
        <input id="observacoes" required v-model="observacoes" type="text" style="left: 0px;"
               placeholder="Informe aqui...">
        <label for="observacoes" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'MERCADOPAGO_CARTAO' && this.mercadopagoCardFormLiberado == true" id="MERCADOPAGO_CARTAO_CAIXA_PAGAMENTO" >
      <div class="input-field" style="padding: 0 0rem 0 0;">
        <titulo-destacado titulo="Pagamento Cartão Online">
          <span v-if="!this.agendamento_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        </titulo-destacado>
        <MercadoPagoCheckoutTransparente :valor_total="this.ObterValorTotalAtualizadoDoPedido()"  :key="this.ObterValorTotalAtualizadoDoPedido()"></MercadoPagoCheckoutTransparente>
        <center>
          <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
          <img height="100" src="@/assets/aguardando.gif"/>
        </center>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'MERCADOPAGO_PIX'" id="MERCADOPAGO_PIX_CAIXA_PAGAMENTO" style="display: none">
      <titulo-destacado titulo="Dados do PIX Online">
        <span v-if="!this.conta_bancaria" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 8px">
          <div class="row">
            <div class="col s12">
              <label class="grey-text text-darken-4">
                <span>
                  <span>
                    <center>
                      <div class=" max-width: 100%;">
                        <p style="padding: 5px; word-wrap: break-word;font-size: small; user-select: text;">
                          {{ this.mercadopago_pix.codigo_copia_cola }}
                        </p>
                      </div>
                      <button @click="CopiarParaAreaDeTransferenciaChavePix()">Copiar Código </button>
                      <br>
                      <img style="padding-top: 7px;max-width: 75%" alt="Código pagamento PIX Online"
                           :src="'data:image/png;base64,' + this.mercadopago_pix.imagem_qrcode"/>
                  </center>
                  </span>
                  <center>
                      <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
                      <img height="100" src="@/assets/aguardando.gif"/>
                  </center>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'SOFTEXPRESS_CARTAO'" id="SOFTEXPRESS_CARTAO_CAIXA_PAGAMENTO" >
      <div class="input-field" style="padding: 0 0rem 0 0;">
        <titulo-destacado titulo="Pagamento Cartão Online">
          <span v-if="!this.agendamento_valido" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        </titulo-destacado>
         <SoftwareExpressCheckoutTransparente></SoftwareExpressCheckoutTransparente>
        <center>
          <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
          <img height="100" src="@/assets/aguardando.gif"/>
        </center>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'PAGHIPER_PIX'" id="PAGHIPER_PIX_CAIXA_PAGAMENTO" style="display: none">
      <titulo-destacado titulo="Dados do PIX Online">
        <span v-if="!this.conta_bancaria" class="tb-fit badge cor-primaria-bg">Obrigatório</span>
        <span v-else class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 8px">
          <div class="row">
            <div class="col s12">
              <label class="grey-text text-darken-4">
                <span>
                  <span>
                    <center>
                      <div class=" max-width: 100%;">
                        <p style="padding: 5px; word-wrap: break-word;font-size: small; user-select: text;">
                          {{ this.paghiper_pix.codigo_copia_cola }}
                        </p>
                      </div>
                      <button @click="CopiarParaAreaDeTransferenciaChavePix()">Copiar Código </button>
                      <br>
                      <img style="padding-top: 7px;max-width: 75%" alt="Código pagamento PIX Online"
                           :src="'data:image/png;base64,' + this.paghiper_pix.imagem_qrcode"/>
                  </center>
                  </span>
                  <center>
                      <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
                      <img height="100" src="@/assets/aguardando.gif"/>
                  </center>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </bloco>

    <div style="padding-top: 100px">
      <caixa-flutuante-inferior v-if="forma_pagamento == 'MERCADOPAGO_PIX' && this.mercadopago_pix_pagamento_realizado == false" altura="70"
                                estilo="background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="EnviarPedido(true)"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.mercadopago_pix_gerado ? ' disabled' : '')">
          <span>{{ this.mercadopago_pix_gerado ? 'Aguardando' : 'Realizar' }} Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
      </caixa-flutuante-inferior>
      <caixa-flutuante-inferior v-else-if="forma_pagamento == 'MERCADOPAGO_CARTAO'" altura="70"
                                estilo="background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="RealizarPagamentoMercadPagoCartao()"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.mercadopago_pagamento_realizado ? ' disabled' : '')">
          <span>{{ !this.mercadopagoCardFormLiberado ? 'Realizar' : 'Confirmar' }} Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
      </caixa-flutuante-inferior>
      <caixa-flutuante-inferior v-else-if="forma_pagamento == 'SOFTEXPRESS_CARTAO'" altura="70"
                                estilo="background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="RealizarPagamentoSoftExpressCartao()"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.softexpress_cartao.pagamento_realizado ? ' disabled' : '')">
          <span>Confirmar Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
      </caixa-flutuante-inferior>
      <caixa-flutuante-inferior v-else-if="forma_pagamento == 'PAGHIPER_PIX' && this.paghiper_pix.pagamento_realizado == false" altura="70"
                                estilo="background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="EnviarPedido(true)"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.paghiper_pix.gerado ? ' disabled' : '')">
          <span>{{ this.paghiper_pix.gerado ? 'Aguardando' : 'Realizar' }} Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
      </caixa-flutuante-inferior>
      <caixa-flutuante-inferior v-else altura="70"
                                estilo="background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="EnviarPedido()"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() ? ' disabled' : '')">
           <span>Enviar Pedido</span> R$ {{
              (
                parseFloat(this.$store.getters.getValorTotalPedido) +
                parseFloat(this.taxa_retorno) -
                parseFloat(this.valor_desconto) +
                (forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0)
              ).toFixed(2)
            }}

        </a>
      </caixa-flutuante-inferior>
    </div>

  </div>
</template>

<script>
import MenuSuperior from '../Widgets/MenuSuperior'
import Bloco from '../Widgets/Bloco'
import TituloDestacado from '../Widgets/TituloDestacado'
import CaixaFlutuanteInferior from '../Widgets/CaixaFlutuanteInferior'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'
import {WMCompose, WMSend} from '@aninga/whatsapp-manager'
import axios from 'axios';
import SecureLS from 'secure-ls'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import VueTheMask from 'vue-the-mask'
import {Money} from 'v-money'
import moment from 'moment-timezone'
import {SalvarEnderecoClienteNoNavegador, SalvarInformacoesDoClienteNoNavegador} from "../../services/storage";
import {
  CalcularFretePorBairroId,
  ObterBairroIdPorBairroNome, ObterBairroPorBairroId, ObterBairroPorBairroNome,
  ObterEnderecoPorCep,
  ValidarCEP, ObterValorFretePorKm
} from "../../services/frete";
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {ObterClienteLogado, SalvarLoginDoClienteNoNavegador} from "../../services/auth";
import MercadoPagoCheckoutTransparente from "../Widgets/MercadoPagoCheckoutTransparente.vue";
import Item from "../Widgets/Item.vue";
import SoftwareExpressCheckoutTransparente from "../Widgets/SoftwareExpressCheckoutTransparente.vue";
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import debounce from 'lodash/debounce';

export default {
  name: "Pedido",
  data() {
    return {
      permitir_endereco_parcial: this.$store.state.empresa.permitir_endereco_parcial,
      naoSeiEndereco: false,
      somenteBairro: this.$store.state.empresa.mostrar_somente_bairro,
      showDescricaoValorEntrega: this.$store.state.empresa.taxa_entrega > 0 ? this.taxa_entrega_v2 : this.$store.state.empresa.empresa_frete_detalhes,
      taxa_entrega_calculo_mensagem_erro: true,
      taxa_entrega_old: 0.00,
      contas: this.$store.state.empresa.contas,
      bandeiras_vale_alimentacao: this.$store.state.empresa.bandeiras_vale_alimentacao,
      bandeira_vale_alimentacao: null,
      bandeiras_vale_refeicao: this.$store.state.empresa.bandeiras_vale_refeicao,
      bandeira_vale_refeicao: null,
      conta_bancaria: null,
      link_pagamento: '',
      link_pagamento_chave_rastreamento: '',
      numero_pedido: 0,
      taxa_entrega_v2: '',
      bairro_id: "",
      nome_cliente: '',
      precisa_troco: true,
      cpf_nota: false,
      cpf: '',
      telefone: '',
      troco_para_quanto: 0,
      forma_pagamento: this.$store.state.empresa.pagamento_dinheiro == "S" ? "DINHEIRO" : "",
      forma_pagamento_obs: "",
      forma_entrega: 'ENTREGA',
      pais_selecionado: '',
      bairros: [],
      endereco: {
        cep: '',
        endereco: '',
        numero: '',
        bairro: '',
        complemento: '',
        uf: 'RO',
        cidade_nome: '',
        salvo_local: false,
        pais: ''
      },
      isLoading: false,
      fullPage: true,
      enderecos_offline: [
        {
          cep: '',
          endereco: '',
          numero: '',
          bairro: '',
          bairro_id: '',
          complemento: '',
          uf: '',
          cidade_nome: '',
        }
      ],
      endereco_offiline_selecionado: null,
      novo_endereco: false,
      endereco_entrega_valido: false,
      troco_valido: false,
      dados_pessoa_valido: false,
      agendamento: false,
      data_agendamento: '',
      hora_agendamento: '',
      agendamento_valido: true,
      agendamento_loja_fechada: false,
      agendamento_liberado: true,
      groups: [],
      cupom_desconto: '',
      cupom_desconto_btn: true,
      cupom_desconto_mensagem: '',
      valor_desconto: 0,
      taxa_retorno: 0,
      observacoes: "",
      ocultarcep: false,
      sobairro: false,
      _mercadopago: null,
      _mercadopagoCardForm:null,
      mercadopagoCardFormLiberado:false,
      _mercadopago_checar_pagamento_intervalo: null,
      mercadopago_pagamento_realizado:false,
      mercadopago_pagamento_cartao_descricao_forma_pagamento:"",
      mercadopago_pagamento_chave_rastreamento:"",
      mercadopago_pix_gerado: false,
      mercadopago_pix_pagamento_realizado: false,
      mercadopago_pix: {
        codigo_copia_cola: "",
        imagem_qrcode: "",
        chave_rastreamento:""
      },
      pedido_enviado: false,
      softexpress_cartao:{
        pagamento_realizado: false,
        pagamento_chave_rastreamento:""
      },
      _paghiper_checar_pagamento_intervalo: null,
      paghiper_pix:{
        gerado: false,
        pagamento_realizado: false,
        codigo_copia_cola: "",
        imagem_qrcode: "",
        chave_rastreamento:""
      },
      horariosSelecionados: [],
      EntregaisDisabled: this.pedidoMinimoEntrega(),
      pedidoEnviadoLinkText: "",
      receber_promocao: "S",
      paises_telefone: this.$store.state.empresa.paises_telefone || null,
      pais_selecionado_obj: null,
      codigoAreaCustom: false,
      showPaisesCombobox: false,
      paisesTelefoneList: [],
      debounceTimeout: null,
    }
  },
  components: {
    SoftwareExpressCheckoutTransparente,
    Item,
    MercadoPagoCheckoutTransparente,
    CaixaFlutuanteInferior, TituloDestacado, Bloco, MenuSuperior, Loading, VueGoogleAutocomplete,
    VueTheMask
  },
    watch: {},
  async mounted() {
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
    window.addEventListener('unload', this.beforeUnloadHandler);
    if (this.$store.state.empresa.pagamento_dinheiro == "S") {
      this.precisa_troco = true
    }
    


    // Initialize paises_telefone from store
    if (this.paises_telefone && typeof this.paises_telefone === 'string') {
      try {
        // console.log('paises_telefone', this.paises_telefone);
        const paisesData = JSON.parse(this.paises_telefone);
        if (paisesData && paisesData.paises && Array.isArray(paisesData.paises)) {
          this.paisesTelefoneList = paisesData.paises;
          this.showPaisesCombobox = true;
        }
      } catch (e) {
        console.error('Erro ao analisar países:', e);
      }
    }

    if (this.$store.state.empresa.mostrar_categoria_wpp == "S") {
      this.$store.state.pedido.itens.forEach(item => {
        item.categorias = _.chain(item.adicionais)
          .groupBy((item) => (item.produto_adicional_cat_id + "[QUEBRA]" + item.cat_nome))
          .map((value, key) => ({descricao: key.split("[QUEBRA]")[1], adicionais: value}))
          .value();
      });
      if (this.somenteBairro === "S") {
        this.naoSeiEndereco = true;
      }
    }

    window.scrollTo(0, 0);
    $(document).ready(function () {
      $('select').formSelect();
    });

    // Initialize country select if countries are available
    if (this.paises_telefone && typeof this.paises_telefone === 'string') {
      $(document).ready(function () {
        $('select').formSelect();
      });
    }

    var dataMax = new Date();
    dataMax = new Date(dataMax.setYear(dataMax.getFullYear() + 1));

    // var horarios = this.$store.state.empresa.horarios;
    var that = this;

    if (this.$store.state.empresa.usa_agendamento == "S" && this.$store.state.empresa.horario_agendamento == "S") {
      this.horariosSelecionados = this.$store.state.empresa.horarios_agendamento;
    } else {
      this.horariosSelecionados = this.$store.state.empresa.horarios;
    }

    // Remove this line as it's overwriting the parsed countries list
    // this.paisesTelefoneList = this.$store.state.empresa.paises_telefone;

    if (this.$store.state.empresa.usa_agendamento == "S") {
      const horarios = this.horariosSelecionados;

      $('.datepicker').datepicker({
        minDate: new Date(),
        maxDate: dataMax,
        selectMonths: true,
        selectYears: 15,
        format: 'dd/mm/yyyy',
        i18n: {
          nextMonth: 'Próximo Mês',
          previousMonth: 'Mês Anterior',
          months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
          weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
          weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          weekdaysAbbrev: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
          clear: 'Limpar',
          cancel: 'Cancelar'
        },
        onClose: function () {
          $(document.activeElement).blur();
          if (this.toString()) {
            that.data_agendamento = this.toString();
            that.hora_agendamento = "";
          }
        },
        disableDayFn: function (date) {
          return !horarios.some(s => s.dia == date.getDay());
        }
      });

      $('.timepicker').timepicker({
        twelveHour: false,
        i18n: {
          clear: 'Limpar',
          cancel: 'Cancelar',
          done: 'OK'
        },
        onCloseEnd: function () {
          if (this.time)
            that.hora_agendamento = this.time;
        }
      });
    }

    if (this.$store.state.pedido.itens.length == 0)
      this.$router.push('/' + this.$router.currentRoute.params.empresa + '/menu');

    if (this.$store.state.empresa.forma_cobranca_frete != 'BAIRRO') {
      this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;
      if (this.taxa_entrega_v2 == "0.00")
        this.taxa_entrega_v2 = "A combinar";
    } else {
      this.$store.state.empresa.taxa_entrega = 0;
    }
    //carregar enderecos offline
    var ls = new SecureLS();
    var enderecos = ls.get('enderecos');
    this.enderecos_offline = enderecos;

    var dados_cliente = ls.get('dados_cliente');
    if (dados_cliente) {
      this.nome_cliente = dados_cliente.nome_cliente;
      this.telefone = dados_cliente.telefone;
      this.cpf_nota = dados_cliente.cpf_nota;
      this.cpf = dados_cliente.cpf;
      if (dados_cliente.pais_telefone && this.paisesTelefoneList.length > 0) {
        const paisSalvo = this.paisesTelefoneList.find(p => p.codigo_area === dados_cliente.pais_telefone);
        if (paisSalvo) {
          this.pais_selecionado_obj = paisSalvo;
        } else {
          this.pais_selecionado_obj = this.paisesTelefoneList[0];
        }
      } else if (this.paisesTelefoneList.length > 0) {
        this.pais_selecionado_obj = this.paisesTelefoneList[0];
      }
    } else if (this.paisesTelefoneList.length > 0) {
      this.pais_selecionado_obj = this.paisesTelefoneList[0];
    }

    if (this.pais_selecionado_obj && !this.telefone) {
      this.telefone = this.pais_selecionado_obj.codigo_area;
    }

    if (this.$store.state.empresa.usa_facebook_pixel == "S") {
      var fbqContents = [];

      this.$store.state.pedido.itens.forEach(prod => {
        fbqContents.push({
          id: 'produto_' + prod.id,
          name: prod.nome,
          quantity: prod.quantidade,
          value: parseFloat(prod.valor)
        });

        prod.adicionais.forEach(ad => {
          fbqContents.push({
            id: 'adicional_' + ad.adicional_id,
            name: ad.nome,
            quantity: prod.quantidade * ad.quantidade,
            value: parseFloat(ad.valor)
          });
        });
      });

      fbq(fbq.track, 'InitiateCheckout' + fbq.src, {
        content_type: 'product',
        value: this.$store.getters.pedidoSubtotal,
        currency: 'BRL',
        contents: fbqContents
      });
    }

    var gtagItens = [];

    this.$store.state.pedido.itens.forEach(prod => {
      gtagItens.push({
        "item_id": 'produto_' + prod.id,
        "item_name": prod.nome,
        "item_category": prod.grupo_nome,
        "quantity": prod.quantidade,
        "currency": "BRL",
        "price": parseFloat("0" + prod.valor)
      });

      prod.adicionais.forEach(ad => {
        gtagItens.push({
          "item_id": 'adicional_' + ad.adicional_id,
          "item_name": ad.nome,
          "quantity": prod.quantidade * ad.quantidade,
          "currency": "BRL",
          "price": parseFloat("0" + ad.valor)
        });
      });
    });

    gtag('event', 'begin_checkout', {"items": gtagItens});

    //Timezone
    this.ativarTimezone();

    this.ChegarProdutosSomenteParaRetirada();

    this.LimparEndereco();

    $('#cupom_desconto_campo').on('keypress', function (event) {
      var regex = new RegExp("^[a-zA-Z0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    });

    this.$store.state.cupom_desconto_valor = 0.00;
    if (this.$store.state.cupom_desconto) {
      this.cupom_desconto = this.$store.state.cupom_desconto;
      this.AplicarDesconto();
    }

    if (this.$store.state.empresa.habilitar_agendamento_fechada == "S" && this.$store.state.empresa.aberto == 'N') {
      this.agendamento = true;
      this.agendamento_liberado = false;
      Swal.fire({
        title: 'Woohoo! 🤑',
        text: 'Nossa loja esta fechada, pedidos apenas por agendamento!',
        icon: 'success',
        customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'}
      })
    }
    if (this.$store.state.empresa) {
      this.ocultarcep = this.$store.state.empresa.ocultar_cep_pedido == "S";
      this.sobairro = this.$store.state.empresa.mostrar_somente_bairro == "S";
      if (this.$store.state.empresa.desconto) {
        this.CalcularDesconto();
      }
      if (this.sobairro) {
        this.naoSeiEndereco = true;
      }
    }
    this.initializePaisesTelefone();
    if(this.paisesTelefoneList.length > 0 && !this.pais_selecionado_obj) {
      this.pais_selecionado_obj = this.paisesTelefoneList[0];
    }
     if (this.pais_selecionado_obj && !this.telefone) {
        this.telefone = this.pais_selecionado_obj.codigo_area;
    }
  },
  created() {
    setTimeout(()=>{
      if(this.$store.state.empresa.modulo_mercadopago_status == 'ATIVO'){
        const publicKey = this.$store.state.empresa.modulo_mercadopago_key;
        this._mercadopago = new MercadoPago(publicKey);
      }
    },500)
  },
  beforeDestroy() {
    if (this._mercadopagoCardForm) {
      this._mercadopagoCardForm.unmount();
    }
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  },
  beforeRouteLeave(to, from, next) {
    let hasUnsavedChanges = false;
    if(this.forma_pagamento == 'PAGHIPER_PIX' && !this.paghiper_pix.pagamento_realizado){
        hasUnsavedChanges = true;
    }
    if(this.forma_pagamento == 'SOFTEXPRESS_CARTAO' && !this.softexpress_cartao.pagamento_realizado){
      hasUnsavedChanges = true;
    }

    if (hasUnsavedChanges) {
      const answer = this.confirmLeave();
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    confirmLeave() {
      return window.confirm("Seu pedido ainda não foi enviado, deseja realmente sair?");
    },
    beforeUnloadHandler(event) {
      if(this.forma_pagamento == 'PAGHIPER_PIX' && !this.pedido_enviado){
        event.preventDefault();
        event.returnValue = '';
      }
      if(this.forma_pagamento == 'SOFTEXPRESS_CARTAO' && !this.pedido_enviado){
        event.preventDefault();
        event.returnValue = '';
      }
    },
    handleFocusout(e) {
      if (!this.PedidoValido() && this.hora_agendamento != "") {
        window.scrollTo({top: 0, behavior: 'smooth'})
      } else {
        window.scrollTo(0, document.body.scrollHeight)
      }
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.endereco.cidade_nome = addressData.locality
      document.getElementById('cidade').value = addressData.locality
      this.endereco.uf = addressData.administrative_area_level_1;
    },
    SelecionarEnderecoSalvo(endoff) {
      this.LimparEndereco();
      this.endereco.endereco = endoff.endereco;
      this.endereco.numero = endoff.numero;
      this.endereco.bairro = endoff.bairro_nome;
      this.endereco.uf = endoff.uf;
      this.endereco.cidade_nome = endoff.cidade_nome;
      this.CalcularFreteDebounced(endoff.bairro_nome);

    },
    ResetValorFrete(forma_entrega) {
      if (forma_entrega == 'RETIRADA') {
        this.taxa_retorno = 0.0;
        this.forma_entrega = forma_entrega;
        this.ObterValorTotalAtualizadoDoPedido();
      }

      if (this.forma_entrega != forma_entrega) {
        this.endereco_offiline_selecionado = null;
        this.LimparEndereco();
        this.pedidoMinimoEntrega();
      }
    },
    myFunction() {
      var copyText = document.getElementById("myInput");
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      alert("Chave copiada: " + copyText.value);
    },
    CopiarParaAreaDeTransferenciaChavePix() {
      const input = document.createElement('input');
      if(this.forma_pagamento == 'MERCADOPAGO_PIX')
        input.value = this.mercadopago_pix.codigo_copia_cola;

      if(this.forma_pagamento == 'PAGHIPER_PIX')
        input.value = this.paghiper_pix.codigo_copia_cola;

      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert('Código copiado! Aguardando pagamento...');
    },
    ChegarProdutosSomenteParaRetirada() {

      var desativarEntrega = false;
      this.$store.state.pedido.itens.forEach(prod => {
        if (prod.somente_retirada == "S") {
          desativarEntrega = true;
        }
      })

      if (this.$store.state.habilitar_retirada == "S") {
        if (desativarEntrega) {
          this.desativarEntrega('Você possui produtos disponiveis somente para retirada.');
          document.getElementById('divEntregaOpcao').style = "display:none";
        } else {
          document.getElementById('divEntregaOpcao').style = "display:block";
        }
      }
    },
    DesativarCAmposEndereco() {
      if (this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') {
        if (document.getElementById("cidade")) {
          document.getElementById("cidade").disabled = true;
        }
        if (document.getElementById("estado")) {
          document.getElementById("estado").disabled = true;
        }
      }
    },
    ativarTimezone() {
      if (this.$store.state.empresa.timezone) {
        moment.tz.setDefault(this.$store.state.empresa.timezone)
      } else {
        moment.tz.setDefault("America/Porto_Velho")
      }
    },
    NovoEndereco() {
      window.scrollTo(0, 200)

      this.LimparEndereco();
      this.novo_endereco = !this.novo_endereco;
      this.endereco_offiline_selecionado = null;
      setTimeout(res => {
        this.DesativarCAmposEndereco()
      }, 500);
      M.toast({html: 'Informe seu endereço 🏠', displayLength: 3000});

      // Limpa os dados do endereço
      this.endereco.cidade_nome = '';
      this.endereco.uf = '';
      this.endereco.bairro = '';
      this.bairro_id = '';
      this.taxa_entrega_calculo_mensagem_erro = true;
    },
    SalvarEndereco() {
      if (!this.naoSeiEndereco)
        SalvarEnderecoClienteNoNavegador(this.endereco.cep, this.endereco.uf, this.endereco.cidade_nome, this.bairro_id, this.endereco.bairro, this.endereco.endereco, this.endereco.numero, this.endereco.complemento)
    },
    SalvarDados() {
      // Só salva se tiver um país selecionado e um telefone válido
      if (this.pais_selecionado_obj && this.telefone) {
        // Garante que o telefone não tenha código de país duplicado
        let telefoneParaSalvar = this.telefone;
        const codigoPais = this.pais_selecionado_obj.codigo_area;
        
        // Remove código duplicado se existir
        if (telefoneParaSalvar.startsWith(codigoPais + codigoPais)) {
          telefoneParaSalvar = codigoPais + telefoneParaSalvar.substring(codigoPais.length);
        }
        
        // Se o telefone não começar com o código do país, adiciona
        if (!telefoneParaSalvar.startsWith(codigoPais)) {
          telefoneParaSalvar = codigoPais + telefoneParaSalvar;
        }
        
        // Remove country code for storage
        if (telefoneParaSalvar.startsWith(codigoPais)) {
          telefoneParaSalvar = telefoneParaSalvar.substring(codigoPais.length);
        }
        
        SalvarInformacoesDoClienteNoNavegador(
          this.nome_cliente, 
          telefoneParaSalvar, // Store without country code
          this.cpf_nota,
          this.cpf,
          codigoPais // Pass just the country code
        );
      }
    },
    RemoverEndereco(itemRemover) {
      Swal.fire({
        title: 'Aviso',
        text: " Deseja realmente remover este endereço ?",
        icon: 'warning',
        customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim',
        showLoaderOnConfirm: true,
        preConfirm: () => {

          this.endereco_offiline_selecionado = null;
          this.LimparEndereco();

          var forDeletion = [];
          forDeletion.push(itemRemover);
          var enderecos = this.enderecos_offline.filter(item => !forDeletion.includes(item))
          this.enderecos_offline = enderecos;
          var ls = new SecureLS();
          ls.set('enderecos', enderecos);

          return true;
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: 'Sucesso',
            text: 'Endereço removido',
            icon: 'success',
            customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'}
          })
        }
      })
    },
    LimparEndereco() {
      if (this.$store.state.empresa.habilitar_entrega == "S") {
        this.forma_entrega = "ENTREGA";
      } else {
        this.forma_entrega = "RETIRADA";
      }

      this.endereco.bairro = "";
      this.endereco.cep = "";
      this.endereco.cidade_nome = "";
      this.endereco.complemento = "";
      this.endereco.numero = "";
      this.endereco.endereco = "";
      this.endereco.uf = "";
      this.novo_endereco = false;
      this.bairro_id = "";
    },
    maxLengthCheck() {
      if (this.endereco.cep.length > 8)
        this.endereco.cep = this.endereco.cep.slice(0, 8)
    },
    desativarEntrega(msg, showToast = true) {
      this.isLoading = false;
      this.bairro_id = "";
      this.$store.state.empresa.taxa_entrega = 0.00;
      if (showToast)
        M.toast({html: msg, displayLength: 5000});

      this.LimparEndereco();

      if (this.$store.state.empresa.retirar_local == 'S') {
        this.forma_entrega = "RETIRADA";
      }
    },
    async AplicarDesconto() {
      let codigoAtivacao = this.cupom_desconto;
      let localizacao = localStorage.getItem('localizacao');
      this.isLoading = true;
      this.cupom_desconto_btn = false;
      this.$store.state.cupom_desconto_valor = 0.00;
      
      // Verifica se existe algum produto elegível para desconto
      if (this.$store.getters.pedidoSubtotalElegivelDesconto <= 0) {
        this.isLoading = false;
        this.cupom_desconto_mensagem = 'Não existem produtos elegíveis para aplicação do cupom de desconto no seu carrinho.';
        return;
      }

      console.log('cupom desconto');
      await axios
        .get(this.$store.state.apiUrl + "cupom-desconto/pre-ativar?empresa=" + this.$store.state.empresa_url + 
             "&subtotal=" + this.$store.getters.pedidoSubtotal.toFixed(2) + 
             "&subtotal_elegivel=" + this.$store.getters.pedidoSubtotalElegivelDesconto.toFixed(2) + 
             "&codigo_ativacao=" + this.cupom_desconto + 
             "&localizacao=" + localizacao)
        .then(res => {
          if (res.data) {
            this.isLoading = false;
            this.$store.state.cupom_desconto_valor = res.data;
            this.cupom_desconto_mensagem = 'Cupom aplicado: Valor R$ ' + res.data + ' (calculado sobre produtos elegíveis)';
          }
        })
        .catch(error => {
          console.log('cupom desconto', error.response.data);
          this.cupom_desconto_mensagem = error.response.data;
          this.isLoading = false;
        });
    },
    CalcularFreteDebounced: debounce(function(parametro) {
      this.CalcularFrete(parametro);
    }, 800),    
    CalcularFrete(parametro) {

      this.isLoading = true;
      this.ChegarProdutosSomenteParaRetirada();

      if (this.forma_entrega !== 'Retirada' && (this.forma_pagamento === 'DEBITO' || this.forma_pagamento === 'CREDITO')) {
          this.taxa_retorno = this.$store.state.empresa.taxa_retorno_maquina;
      }

      if (this.forma_entrega !== 'Retirada' && (this.forma_pagamento === 'DINHEIRO') && this.precisa_troco) {
          this.taxa_retorno = this.$store.state.empresa.taxa_retorno_troco;
      }   
    
      if ((this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') && (parametro != '')) {
        this.isLoading = true;
        if (Number.isInteger(parametro)) {
          this.$store.state.empresa.taxa_entrega = CalcularFretePorBairroId(this.$store.state.empresa.tarifas_entrega_bairro, parametro)
          this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;

          var bairro = ObterBairroPorBairroId(this.$store.state.empresa.tarifas_entrega_bairro, parametro);
          this.endereco.uf = bairro.uf;
          this.endereco.cidade_nome = bairro.cidade;
          this.endereco.bairro = bairro.bairro;
          this.bairro_id = bairro.bairro_id;
          this.isLoading = false;
          this.taxa_entrega_calculo_mensagem_erro = false;
          M.toast({
            html: 'Taxa de entrega aplicada: R$ ' + this.$store.state.empresa.taxa_entrega,
            displayLength: 5000
          });
        } else {
          this.CalcularFretePorBairroNome(parametro);
        }

      }

      if ((this.$store.state.empresa.forma_cobranca_frete == 'KM') || (this.$store.state.empresa.forma_cobranca_frete == 'FIXO_KM')) {

        this.isLoading = true;
        if (this.endereco.endereco && this.endereco.numero && this.endereco.bairro) {

          axios.post(this.$store.state.apiUrl + 'empresa/calcular-frete-por-geolocalizacao', {
            "empresa_usuario": this.$store.state.empresa.usuario_url,
            "endereco_entrega": this.endereco.endereco + ', ' + (this.endereco.numero || '') + ' - ' + this.endereco.bairro + ', ' + this.endereco.cidade_nome
          }).then(res => {
            this.isLoading = false;
            var taxa_frete = parseFloat(res.data.valor_frete).toFixed(2);
            if (this.taxa_entrega_old != taxa_frete) {
              this.$store.state.empresa.taxa_entrega = taxa_frete;
              this.taxa_entrega_old = taxa_frete;
              this.taxa_entrega_v2 = taxa_frete;
              M.toast({
                html: 'Taxa de entrega atualizada: R$ ' + this.$store.state.empresa.taxa_entrega,
                displayLength: 5000
              });
            }
            this.taxa_entrega_calculo_mensagem_erro = false;
          }).catch(error => {
            this.isLoading = false;
            M.toast({html: "<strong class='red-text'>Endereço inválido</strong>", displayLength: 4000});
            this.taxa_entrega_calculo_mensagem_erro = true;
            if (error.response.status == 404) {
              this.desativarEntrega(error.response.data)
            } else {
              M.toast({html: "<strong class='red-text'>" + error.response.data + "</strong>", displayLength: 4000});
            }
            return null;

          });
        } else {
          this.isLoading = false;
        }
      }

      if (this.$store.state.empresa.forma_cobranca_frete == 'TABELA_KM') {
        this.isLoading = true;
        if (this.endereco.endereco && this.endereco.numero && this.endereco.bairro) { //calcular-distancia-entrega
          axios.post(this.$store.state.apiUrl + 'empresa/calcular-frete-por-geolocalizacao', {
            "empresa_usuario": this.$store.state.empresa.usuario_url,
            "endereco_entrega": this.endereco.endereco + ', ' + (this.endereco.numero || '') + ' - ' + this.endereco.bairro + ', ' + this.endereco.cidade_nome
          }).then(res => {
            this.taxa_entrega_calculo_mensagem_erro = false;
            this.isLoading = false;
            let valor = 0;
            
            if (this.$store.state.empresa.usar_integracao_juma == "S")
            valor = res.data.valor_frete
            else
            valor = ObterValorFretePorKm(this.$store.state.empresa.tarifas_entreg_k_m, res.data.distancia_km);

            var taxa_frete = parseFloat(valor).toFixed(2);
            if (this.taxa_entrega_old != taxa_frete) {
              this.$store.state.empresa.taxa_entrega = taxa_frete;
              this.taxa_entrega_old = taxa_frete;
              this.taxa_entrega_v2 = taxa_frete;
              M.toast({
                html: 'Taxa de entrega atualizada: R$ ' + this.$store.state.empresa.taxa_entrega,
                displayLength: 5000
              });
            }
            var totalsomando = parseFloat(this.$store.getters.getValorTotalPedido) - parseFloat(this.valor_desconto);
            if (parseFloat(this.$store.state.empresa.valor_sem_frete) > 0 && parseFloat(totalsomando) > parseFloat(this.$store.state.empresa.valor_sem_frete)) {
              if (this.taxa_entrega_v2 > 0) {
                M.toast({html: "<strong>Não iremos te cobrar frete nesta compra</strong>", displayLength: 4000});
              }

              this.taxa_entrega_v2 = 0;
              this.taxa_entrega_old = 0;
              this.$store.state.empresa.taxa_entrega = 0;
              this.taxa_entrega_calculo_mensagem_erro = false;
            }
          }).catch(error => {
            this.isLoading = false;
            M.toast({html: "<strong class='red-text'>Endereço inválido</strong>", displayLength: 4000});
            this.taxa_entrega_calculo_mensagem_erro = true;
          });
        } else {
          this.isLoading = false;
        }
      }

      if (this.$store.state.empresa.forma_cobranca_frete == 'FIXO') {
        this.isLoading = false;
        this.taxa_entrega_calculo_mensagem_erro = false;
        // this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;
        // M.toast({
        //   html: 'Taxa de entrega aplicada: R$ ' + this.$store.state.empresa.taxa_entrega,
        //   displayLength: 5000
        // });
      }

      this.ChegarProdutosSomenteParaRetirada();
      //this.isLoading = false;

      if ((this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') && (parametro == '')) {
        this.isLoading = false;
      }

      if (parseFloat(this.$store.state.empresa.valor_sem_frete) > 0 && (parseFloat(this.$store.getters.getValorTotalPedido) - this.valor_desconto) > parseFloat(this.$store.state.empresa.valor_sem_frete)
        && this.$store.state.empresa.forma_cobranca_frete != 'TABELA_KM') {
        if (this.taxa_entrega_v2 > 0) {
          M.toast({html: "<strong>Não iremos te cobrar frete nesta compra</strong>", displayLength: 4000});
        }

        this.taxa_entrega_v2 = 0;
        this.$store.state.empresa.taxa_entrega = 0;
        this.taxa_entrega_calculo_mensagem_erro = false;
      }
      this.ObterValorTotalAtualizadoDoPedido();
      return;


    },
    CalcularFretePorBairroNome(nome_bairro) {
      this.isLoading = false;
      this.bairro_id = ObterBairroIdPorBairroNome(this.$store.state.empresa.tarifas_entrega_bairro, nome_bairro);
      if (this.bairro_id != 0) {
        this.CalcularFreteDebounced(this.bairro_id)
      } else {
        this.desativarEntrega('Região indisponivel', true);
      }
      this.isLoading = false;
    },
    PesquisarCep() {
      try {
        
          if (!ValidarCEP(this.endereco.cep))
            return;

          this.isLoading = true;
          ObterEnderecoPorCep(this.endereco.cep).then(response => {

            this.endereco = response;

            this.bairro_id = ObterBairroIdPorBairroNome(this.$store.state.empresa.tarifas_entrega_bairro, response.bairro);

            if (this.bairro_id != 0) {
              if (this.$store.state.empresa.forma_cobranca_frete != 'TABELA_KM') {
                this.CalcularFreteDebounced(this.bairro_id)
              }
              // this.endereco = response;
            } else {
              if (this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') {
                this.desativarEntrega('Região indisponivel', true);
              }
              //M.toast({html: "<strong class='red-text'>Região indisponivel</strong>", displayLength: 4000 });
            }

            
          });
      } catch (error) {

      } finally {
        this.isLoading = false;
      }  
    },
    PedidoValido() {

      if ((this.$store.state.pedido.itens.length <= 0)) {
        return false;
      }

      if (this.forma_entrega == "ENTREGA") {

        this.EntregaisDisabled = this.pedidoMinimoEntrega();
        if ((this.EntregaisDisabled)) {
          return false;
        }

        if (this.endereco.numero == null)
          this.endereco.numero = ""

        if (this.endereco.complemento == null)
          this.endereco.complemento = ""

        if (this.endereco_offiline_selecionado != null) {
          this.endereco_entrega_valido =
            (!this.taxa_entrega_calculo_mensagem_erro) && (this.endereco_offiline_selecionado.endereco != "") &&
            (this.endereco_offiline_selecionado.bairro_nome != "" && this.endereco_offiline_selecionado.bairro_nome) &&
            (this.endereco_offiline_selecionado.complemento != "" || this.endereco_offiline_selecionado.numero) &&
            (this.endereco_offiline_selecionado.cidade_nome != "" && this.endereco_offiline_selecionado.cidade_nome) &&
            (this.endereco_offiline_selecionado.uf != "");
        } else {
          if (this.$store.state.empresa.forma_cobranca_frete == 'FIXO') {
            this.taxa_entrega_calculo_mensagem_erro = false;
          }
          this.endereco_entrega_valido =
            (!this.taxa_entrega_calculo_mensagem_erro) && (this.endereco.endereco != "") &&
            (this.endereco.bairro != "" && this.endereco.bairro) &&
            ((this.endereco.complemento != "") || (this.endereco.numero != "")) &&
            (this.endereco.uf != "") &&
            (this.endereco.cidade_nome != "" && this.endereco.cidade_nome);
        }

        this.troco_valido = ((this.precisa_troco && this.troco_para_quanto > this.$store.getters.pedidoTotal) || !this.precisa_troco);
      } else {
        this.endereco_entrega_valido = true;
        this.troco_valido = ((this.precisa_troco && this.troco_para_quanto > this.$store.getters.pedidoSubtotal) || !this.precisa_troco);
      }

      $('#troco_valor').removeClass('invalid');
      if (!this.troco_valido && this.troco_para_quanto > 0)
        $('#troco_valor').addClass('invalid');

      $('#telefone').removeClass('invalid');
      if (this.telefone != "" && this.telefone.length < 14)
        $('#telefone').addClass('invalid');

      // Validate custom country code if enabled
      if (this.codigoAreaCustom && (!this.pais_selecionado_obj || !this.pais_selecionado_obj.codigo_area.match(/^\+\d{1,4}$/))) {
        M.toast({html: 'Por favor, insira um código de país válido (ex: +44)', displayLength: 3000});
        return false;
      }

      $('#cpf').removeClass('invalid');
      if (this.cpf_nota && this.cpf && !this.validarCPF(this.cpf)) {
        $('#cpf').addClass('invalid');
      }

      this.agendamento_valido = (!this.agendamento) || (this.data_agendamento != "" && this.hora_agendamento != "");

      // Updated CPF validation logic
      const cpfIsValid = !this.cpf_nota || (this.cpf && this.validarCPF(this.cpf));
      this.dados_pessoa_valido = (this.nome_cliente != "") && this.isTelefoneValido && cpfIsValid;

      let enderecoValido = this.endereco_entrega_valido;
      if (this.naoSeiEndereco && this.endereco.endereco.length > 3) {
        enderecoValido = true;
      }

      return (enderecoValido) && (this.forma_pagamento) &&
        (this.troco_valido) && (this.dados_pessoa_valido) && (this.agendamento_valido);
    },
    ObterValorTotalAtualizadoDoPedido() {
      if (this.forma_entrega != 'RETIRADA' && this.forma_pagamento == 'DINHEIRO' && this.precisa_troco) {
            this.taxa_retorno = this.$store.state.empresa.taxa_retorno_troco;
      } else
      if ((this.forma_entrega != 'RETIRADA') && (this.forma_pagamento == 'DEBITO' || this.forma_pagamento == 'CREDITO')) {
            this.taxa_retorno = this.$store.state.empresa.taxa_retorno_maquina;
      }
      return (parseFloat((this.$store.getters.getValorTotalPedido + parseFloat(this.taxa_retorno)) - this.valor_desconto) + (this.forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0)).toFixed(2);
    },
    addFieldErrorMessages(input, validationErrorMessages, error) {
      if (error) {
        input.classList.add('validation-error');
        error.forEach((e, index) => {
          const p = document.createElement('p');
          p.id = `${input.id}-${index}`;
          p.innerText = e.message;
          validationErrorMessages.appendChild(p);
        });
      } else {
        input.classList.remove('validation-error');
      }
    },
    removeFieldErrorMessages(input, validationErrorMessages) {
      Array.from(validationErrorMessages.children).forEach(child => {
        const shouldRemoveChild = child.id.includes(input.id);
        if (shouldRemoveChild) {
          validationErrorMessages.removeChild(child);
        }
      });
    },
    enableOrDisablePayButton(validationErrorMessages, payButton) {
      if (validationErrorMessages.children.length > 0) {
        payButton.setAttribute('disabled', true);
      } else {
        payButton.removeAttribute('disabled');
      }
    },
    validarEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    },
    loadCardForm() {

      const payButton = document.getElementById("form-checkout__submit");
      const validationErrorMessages= document.getElementById('validation-error-messages');

      const form = {
        id: "form-checkout",
        cardholderName: {
          id: "form-checkout__cardholderName",
          placeholder: "Nome no cartão",
        },
        cardholderEmail: {
          id: "form-checkout__cardholderEmail",
          placeholder: "informe um E-mail válido",
        },
        cardNumber: {
          id: "form-checkout__cardNumber",
          placeholder: "Número Cartão",
          style: {
            fontSize: "1rem"
          },
        },
        expirationDate: {
          id: "form-checkout__expirationDate",
          placeholder: "MÊS/ANO",
          style: {
            fontSize: "1rem"
          },
        },
        securityCode: {
          id: "form-checkout__securityCode",
          placeholder: "Código",
          style: {
            fontSize: "1rem"
          },
        },
        installments: {
          id: "form-checkout__installments",
          placeholder: "Parcelas",
        },
        identificationType: {
          id: "form-checkout__identificationType",
        },
        identificationNumber: {
          id: "form-checkout__identificationNumber",
          placeholder: "Número CPF/CNPJ",
        },
        issuer: {
          id: "form-checkout__issuer",
          placeholder: "Emissor",
        },
      };

      this._mercadopagoCardForm = this._mercadopago.cardForm({
        amount: this.ObterValorTotalAtualizadoDoPedido(),
        iframe: true,
        form,
        callbacks: {
          onFormMounted: error => {
            if (error)
              return console.warn("Form Mounted handling error: ", error);
          },
          onSubmit: event => {
            event.preventDefault();
            this.isLoading = true;
            const {
              paymentMethodId,
              issuerId,
              cardholderEmail: email,
              amount,
              token,
              identificationNumber,
              identificationType,
            } = this._mercadopagoCardForm.getCardFormData();

            // Verificar se o e-mail é válido
            if (!this.validarEmail(email)) {
                alert("Por favor, insira um e-mail válido.");
                this.isLoading = false;
                return; // Impede o envio da solicitação se o e-mail não for válido
            }

            const partesNome = this.nome_cliente ? this.nome_cliente.split(' ') : [''];
            const telefoneSemMascara = this.telefone.replace(/\D|\s/g, '');

            fetch(this.$store.state.apiUrl + "empresa/"+ this.$store.state.empresa_url +"/pedidos/processar-pagamento-via-cartao", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-meli-session-id": MP_DEVICE_SESSION_ID,
              },
              body: JSON.stringify({
                token,
                issuerId,
                paymentMethodId,
                transactionAmount: Number(amount),
                installments: Number(1),
                description: "Pedido Delivery",
                payer: {
                  email,
                  phoneNumber : telefoneSemMascara.substring(2, 11),
                  phoneCode : telefoneSemMascara.substring(0, 2),
                  firstName : partesNome[0],
                  lastName : partesNome.length > 1 ? partesNome.slice(1).join(' ') : '',
                  identification: {
                    type: identificationType,
                    number: identificationNumber,
                  },
                },
              }),
            }).then(response => {
              return response.json();
            })
              .then(result => {

                if(!result.hasOwnProperty("error_message")) {
                  let liberarBotaoConsultaManual = false;
                  this.mercadopago_pagamento_chave_rastreamento = result.chave_rastreamento;

                  switch (result.status) {
                    case "approved":
                      alert("Pagamento aprovado");
                      this.isLoading = false;
                      this.mercadopago_pagamento_realizado = true;
                      this.mercadopago_pagamento_cartao_descricao_forma_pagamento = result.forma_pagamento;
                      this.EnviarPedido()
                      break;
                    case "pending":
                      liberarBotaoConsultaManual = true;
                      this.mercadopago_pagamento_realizado = true;
                      this.mercadopago_pagamento_cartao_descricao_forma_pagamento = result.forma_pagamento;
                      alert("Pagamento pendente");
                      this.isLoading = false;
                      break;
                    case "in_process":
                      liberarBotaoConsultaManual = true;
                      this.mercadopago_pagamento_realizado = true;
                      this.mercadopago_pagamento_cartao_descricao_forma_pagamento = result.forma_pagamento;
                      alert("Pagamento em processo");
                      this.isLoading = false;
                      break;
                    case "rejected":
                      alert("Pagamento rejeitado");
                      break;
                    case "refunded":
                      alert("Pagamento reembolsado");
                      break;
                    case "cancelled":
                      alert("Pagamento cancelado");
                      break;
                    case "in_mediation":
                      alert("Pagamento em mediação");
                      break;
                    default:
                      alert("Status de pagamento desconhecido: "+result.status);
                  }

                  if(result.status != 'approved' && liberarBotaoConsultaManual != true){
                    this._mercadopagoCardForm.unmount();
                    this.mercadopagoCardFormLiberado = false;
                    this.isLoading = false;
                  }


                  if(liberarBotaoConsultaManual){
                    this._mercadopago_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamento, 15000);
                    setTimeout(() => {
                      clearInterval(this._mercadopago_checar_pagamento_intervalo);
                    }, 300000);
                  }

                  return ;
                } else {
                  alert(result.error_message);
                  this.isLoading = false;
                  alert("01");
                }
              })
              .catch(error => {
                this.isLoading = false;
                alert("Unexpected error\n"+JSON.stringify(error));
                alert("02");
              });
          },
          onFetching: (resource) => {
            payButton.setAttribute('disabled', true);
            return () => {
              payButton.removeAttribute("disabled");
            };
          },
          onCardTokenReceived: (errorData, token) => {
            if (errorData && errorData.error.fieldErrors.length !== 0) {
              errorData.error.fieldErrors.forEach(errorMessage => {
                alert(errorMessage);
              });
            }

            return token;
          },
          onValidityChange: (error, field) => {
            const input = document.getElementById(form[field].id);
            this.removeFieldErrorMessages(input, validationErrorMessages);
            this.addFieldErrorMessages(input, validationErrorMessages, error);
            this.enableOrDisablePayButton(validationErrorMessages, payButton);
          }
        },
      });
    },
    RealizarPagamentoMercadPagoCartao() {
      this.isLoading = true;

      if(this.ObterValorTotalAtualizadoDoPedido() < 0.5){
        this.isLoading = false;
        M.toast({html: "<strong class='red-text'>O valor mínimo aceito é R$0.50</strong>", displayLength: 4000});
        return false;
      }

      if(!this.mercadopagoCardFormLiberado){
        this.mercadopagoCardFormLiberado = true;
        setTimeout(()=>{
          this.loadCardForm();
          document.getElementById("MERCADOPAGO_CARTAO_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});
          this.isLoading = false;
          M.toast({html: 'Preencha os dados do seu cartão!', displayLength: 3000});
        },500);
        return;
      }
      const validationErrorMessages= document.getElementById('validation-error-messages');
      const cardNumber = document.getElementById("form-checkout__cardNumber").value;
      const cardholderName = document.getElementById("form-checkout__cardholderName").value;
      const cardholderEmail = document.getElementById("form-checkout__cardholderEmail").value;
      const securityCode = document.getElementById("form-checkout__securityCode").value;
      const identificationNumber = document.getElementById("form-checkout__identificationNumber").value;

      if(validationErrorMessages.children.length > 0 ||
        cardholderName == "" || cardNumber == "" ||
        cardholderEmail == "" || securityCode == "" || identificationNumber == "" ){
        this.isLoading = false;
        M.toast({html: "<strong class='red-text'>Informações de pagamento inválidas</strong>", displayLength: 4000});
        return false;
      }

      this.isLoading = true;
      document.getElementById("form-checkout__submit").click();
      setTimeout(() => {
        //this.isLoading = false;
      },3000)
    },
    RealizarPagamentoMercadPagoPix(data) {

      if(data){
        this.mercadopago_pix_gerado = true;
        this.mercadopago_pix = data;
        this.isLoading = false;

        $("#MERCADOPAGO_PIX_CAIXA_PAGAMENTO").show();
        setTimeout(() => {
          document.getElementById("MERCADOPAGO_PIX_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});

          this._mercadopago_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamento, 15000);
          setTimeout(() => {
            clearInterval(this._mercadopago_checar_pagamento_intervalo);
          }, 300000);

        }, 500);
      } else {
        Swal.fire({
            title: 'Aviso!',
            text: 'Ocorreu um erro ao gerar o Pix para pagamento! Tente novamente',
            icon: 'error',
            customClass: {confirmButton: 'confirm-button-class materialize-red'}
          });
      }

    },
    RealizarPagamentoPagHiperPix(data) {

      this.paghiper_pix.gerado = true;
      this.paghiper_pix.codigo_copia_cola = data.codigo_copia_cola;
      this.paghiper_pix.imagem_qrcode = data.imagem_qrcode;
      this.paghiper_pix.chave_rastreamento = data.chave_rastreamento;
      $("#PAGHIPER_PIX_CAIXA_PAGAMENTO").show();
      setTimeout(() => {
        document.getElementById("PAGHIPER_PIX_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});

        this._paghiper_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamentoPagHiper, 15000);
        setTimeout(() => {
          clearInterval(this._paghiper_checar_pagamento_intervalo);
        }, 300000);

      }, 500);
    },
    RealizarPagamentoSoftExpressCartao()
    {
      this.isLoading = true;
      $.ajax({
            url: this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url + '/pagamento/cartao-softexpress',
            data: {
              softwareExpressNome: $('#softwareExpressNome').val(),
              softwareExpressMesAno: $('#softwareExpressMesAno').val(),
              softwareExpressNumero: $('#softwareExpressNumero').val(),
              softwareExpressCVC: $('#softwareExpressCVC').val(),
              softwareExpressBandeira: $('#softwareExpressBandeira').val(),
              softwareExpressValor: this.ObterValorTotalAtualizadoDoPedido(),
            },
            type: "POST",
            success: (data) => {
              this.isLoading = false;
              this.softexpress_cartao.pagamento_chave_rastreamento = data.chave_rastreamento;
              this.softexpress_cartao.pagamento_realizado = true;
              this.EnviarPedido()
            },
            error: (data) => {
              this.isLoading = false;
              var erro = "Erro ao realizar pagamento";
              if (data.responseJSON && data.responseJSON.message) {
                  erro = data.responseJSON.message;
              }
              Swal.fire({
                title: 'Aviso!',
                text: erro,
                icon: 'error',
                customClass: {confirmButton: 'confirm-button-class materialize-red'}
              });
          }
      });
    },
    ConsultarStatusPagamento() {
      let chaveRastreamento = '';

      if(this.forma_pagamento == 'MERCADOPAGO_PIX'){
        chaveRastreamento = this.mercadopago_pix.chave_rastreamento;
      }
      if(this.forma_pagamento == 'MERCADOPAGO_CARTAO'){
        chaveRastreamento = this.mercadopago_pagamento_chave_rastreamento;
      }

      $.ajax({
        url: this.$store.state.apiUrl + "mercadopago/pagamentos-pre-pagamento?rastrear=" + chaveRastreamento,
        type: "GET",
        success: (data) => {
            if(data.status == 'PAGO'){
              if(this.forma_pagamento == 'MERCADOPAGO_PIX'){
                this.mercadopago_pix_pagamento_realizado = true;
              }
              if(this.forma_pagamento == 'MERCADOPAGO_CARTAO'){
                this.mercadopago_pagamento_realizado = true;
              }
              clearInterval(this._mercadopago_checar_pagamento_intervalo);
              this.EnviarPedidoPago();
            }
        },
        error: (data) => {

        }
      });
    },
    ConsultarStatusPagamentoPagHiper() {
      let chaveRastreamento = this.paghiper_pix.chave_rastreamento;
      $.ajax({
        url: this.$store.state.apiUrl + "paghiper/consultar-pagamento-pix/" + chaveRastreamento,
        type: "GET",
        success: (data) => {
            if(data.status == 'PAGO'){
              this.paghiper_pix.pagamento_realizado = true;
              clearInterval(this._paghiper_checar_pagamento_intervalo);
              this.EnviarPedidoPago();
            }
        },
        error: (data) => {

        }
      });
    },
    async EnviarPedidoPago(){
      Swal.fire({
            title: 'Recebemos seu pagamento!</br>' + this.$store.state.pedido.nome_cliente,
            icon: 'success',
            confirmButtonText: 'Enviar Pedido',
            customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
            onClose: () => {
              axios.put(this.$store.state.apiUrl + 'empresa/' +this.$store.state.empresa_url + '/pedidos/marcar-enviado/' + Cookies.get(this.$route.params.id))
              .then(res => {
                this.pedido_enviado = true;

                if (this.$store.state.empresa.receber_pedidos_whatsapp == "S")
                  this.EnviarParaWhatsApp();

                var ls = new SecureLS();
                this.$store.state.pedido.itens.forEach(prod => {
                  ls.remove('prod' + prod.id);
                });

                if (this.isInstagramOnIOS()) {
                      const url = 'https://api.whatsapp.com/send?phone='+ this.$store.state.empresa.whatsapp +'&text=' + encodeURIComponent(this.pedidoEnviadoLinkText);
                      window.location.href = url;
                    }else{
                      this.IrParaPagina();
                }
              })
              .catch(err => {
                this.isLoading = false;
              });
          }
      });
    },    
    async EnviarPedido(pedido_temporario = false) {


      if(this.forma_pagamento == 'PAGHIPER_PIX' && this.paghiper_pix.pagamento_realizado == true){
        return this.EnviarPedidoPago();
      };

      if(this.forma_pagamento == 'MERCADOPAGO_PIX' && this.mercadopago_pix_pagamento_realizado == true){
        return this.EnviarPedidoPago();
      };

      if (!this.PedidoValido()) {
        M.toast({html: 'Informe todos os dados para processeguir!', displayLength: 3000});
        return;
      }

      if (!this.telefone) {
        M.toast({html: "<strong class='red-text'>Informe um telefone válido</strong>", displayLength: 4000});
        document.getElementById("telefone").focus();
        return false;
      }

      if (!this.isTelefoneValido) {
        M.toast({html: "<strong class='red-text'>Informe um telefone válido</strong>", displayLength: 4000});
        document.getElementById("telefone").focus();
        return false;
      }
      

      if (!this.validarCPF(this.cpf)) {
        if (this.cpf_nota) {
          M.toast({html: "<strong class='red-text'>CPF Inválido</strong>", displayLength: 4000});
          return false;
        } else {
          this.cpf = "";
        }
      }

      if (this.forma_entrega == "ENTREGA") {
        if (this.endereco_offiline_selecionado != null) {
          this.endereco.cep = this.endereco_offiline_selecionado.cep;
          this.endereco.uf = this.endereco_offiline_selecionado.uf;
          this.endereco.cidade_nome = this.endereco_offiline_selecionado.cidade_nome;
          this.bairro_id = this.endereco_offiline_selecionado.bairro_id;
          this.endereco.bairro = this.endereco_offiline_selecionado.bairro_nome;
          this.endereco.endereco = this.endereco_offiline_selecionado.endereco;
          this.endereco.numero = this.endereco_offiline_selecionado.numero;
          this.endereco.complemento = this.endereco_offiline_selecionado.complemento;
        }
      }

      var pedido = this.$store.state.pedido;
      pedido.pedido_temporario = (pedido_temporario) ? 'S' : 'N';
      pedido.nome_cliente = this.nome_cliente;
      pedido.cpf = this.cpf;
      pedido.telefone = this.telefone;
      pedido.pais_telefone = this.pais_selecionado_obj ? this.pais_selecionado_obj.codigo_area : null;
      pedido.forma_pagamento = this.forma_pagamento;
      pedido.forma_entrega = this.forma_entrega;
      pedido.precisa_troco = this.precisa_troco ? 'S' : 'N';
      pedido.troco_para_quanto = this.troco_para_quanto;
      pedido.entrega_cep = this.endereco.cep;
      pedido.entrega_bairro = this.endereco.bairro;
      pedido.entrega_endereco = this.endereco.endereco;
      pedido.entrega_cidade = this.endereco.cidade_nome;
      pedido.entrega_uf = this.endereco.uf;
      pedido.entrega_numero = this.endereco.numero;
      pedido.entrega_complemento = this.endereco.complemento;
      pedido.agendado = this.agendamento ? "S" : "N";
      pedido.data_agendamento = this.data_agendamento;
      pedido.hora_agendamento = this.hora_agendamento;
      pedido.taxa_entrega = this.$store.state.empresa.taxa_entrega;

      if (this.forma_pagamento != 'DINHEIRO') {
        pedido.taxa_retorno_maquina = this.taxa_retorno;
      } else {
        pedido.taxa_retorno_maquina = 0;
      }
      
      if (this.forma_pagamento === 'DINHEIRO' && this.precisa_troco) {
        pedido.taxa_retorno_troco = this.taxa_retorno;
      } else {
        pedido.taxa_retorno_troco = 0;
      } 

      if (this.forma_pagamento === 'MERCADOPAGO_PIX') {
        pedido.chave_pre_pagamento = this.mercadopago_pix.chave_rastreamento;
      }
      if(this.forma_pagamento === 'MERCADOPAGO_CARTAO'){
        pedido.chave_pre_pagamento = this.mercadopago_pagamento_chave_rastreamento;
      }
      if(this.forma_pagamento === 'PAGHIPER_PIX'){
        pedido.chave_pre_pagamento = this.paghiper_pix.chave_rastreamento;
      }
      if(this.forma_pagamento === 'SOFTEXPRESS_CARTAO'){
        pedido.chave_pre_pagamento = this.softexpress_cartao.pagamento_chave_rastreamento;
      }
      if (this.valor_desconto == 0)
        pedido.valor_desconto = this.$store.state.cupom_desconto_valor
      else
        pedido.valor_desconto = this.valor_desconto

      pedido.cupom_desconto_codigo = this.cupom_desconto;
      pedido.observacoes = this.observacoes;

      if (this.$store.state.multilink_ativo) {
        pedido.multilink_ativo = "S";
      } else {
        pedido.multilink_ativo = "N";
      }
      pedido.receber_promocao = this.receber_promocao ? 'S' : 'N';

      var novoPedido = this.$store.state.pedido;

      if (this.conta_bancaria) {
        if (((this.conta_bancaria.ativo === "S") && (this.forma_pagamento === "TRANSFERENCIA"))) {
          novoPedido.conta_bancaria_id = this.conta_bancaria.codigo_interno;
        }
      }

      if (this.bandeira_vale_alimentacao) {
        novoPedido.bandeira_vale_alimentacao_codigo_interno = this.bandeira_vale_alimentacao.codigo_interno;
      }

      if (this.bandeira_vale_refeicao) {
        novoPedido.bandeira_vale_refeicao_codigo_interno = this.bandeira_vale_refeicao.codigo_interno;
      }


      novoPedido.itens = this.PrepararLista();

      this.isLoading = false;


      try {
        novoPedido.pedido_html = this.ObterHTMLdoPedido();
      } catch (e) {

      }

      try {
        ObterClienteLogado().then( async clienteLogado => {
          if (clienteLogado && clienteLogado != null) {
            pedido.cliente_id = clienteLogado.id;
          } else {
            this.FazerLogin().then(async id => {if(id) pedido.cliente_id = id})
          }
        }).catch(err => {
        });
      } catch (e) {
      }

      pedido.enviado = pedido_temporario ? 'N' : 'S';

      let isPrePagamento = this.mercadopago_pix_pagamento_realizado || this.mercadopago_pagamento_realizado || this.paghiper_pix.pagamento_realizado || this.softexpress_cartao.pagamento_realizado;

      //return console.log(novoPedido);
      // return false;
      Swal.fire({
        title: 'Aviso',
        text: !isPrePagamento ? " Deseja confirmar este pedido?" : "Seu pagamento foi recebido!",
        icon: 'info',
        customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
        showCancelButton: !isPrePagamento,
        cancelButtonText: 'Cancelar',
        confirmButtonText: !isPrePagamento ? " Sim" : "Enviar Pedido",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return $.ajax({
            url: this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url + '/pedidos/novo',
            data: novoPedido,
            type: "POST",
            success: (data) => {
              Swal.hideLoading();
              this.numero_pedido = data[0];
              if (this.forma_pagamento == 'MERCADOPAGOLINK') {
                this.link_pagamento_chave_rastreamento = data[1];
                this.link_pagamento = data[2];
              }
              if (this.forma_pagamento == 'PAGHIPER_PIX') {
                this.RealizarPagamentoPagHiperPix(data[1])
              }
              if (this.forma_pagamento == 'MERCADOPAGO_PIX') {
                this.RealizarPagamentoMercadPagoPix(data[1])
              }

              return true;
            },
            error: (data) => {
              var erro = "Erro ao enviar o seu pedido para o servidor";
              if (data.status < 500 && data.responseJSON.length > 0) {
                erro = data.responseJSON[0];
              }

              Swal.fire({
                title: 'Aviso!',
                text: erro,
                icon: 'error',
                customClass: {confirmButton: 'confirm-button-class materialize-red'}
              });

              return false;
              // return true;
            }
          });
        },
        allowOutsideClick: () => false
      }).then((result) => {
        if (result.value) {
          if (this.forma_entrega == "ENTREGA" && !this.endereco_offiline_selecionado)
            this.SalvarEndereco();

          this.SalvarDados();

          if (this.$store.state.empresa.usa_facebook_pixel == "S") {

            var fbqContents = [];

            this.$store.state.pedido.itens.forEach(prod => {
              fbqContents.push({
                id: 'produto_' + prod.id,
                name: prod.nome,
                quantity: prod.quantidade,
                value: parseFloat(prod.valor)
              });

              prod.adicionais.forEach(ad => {
                fbqContents.push({
                  id: 'adicional_' + ad.adicional_id,
                  name: ad.nome,
                  quantity: prod.quantidade * ad.quantidade,
                  value: parseFloat(ad.valor)
                });
              });
            });

            fbq(fbq.track, 'Purchase' + fbq.src, {
              content_type: 'product',
              value: (this.forma_entrega == 'ENTREGA' ? this.$store.getters.pedidoTotal : this.$store.getters.pedidoSubtotal),
              currency: 'BRL',
              contents: fbqContents
            });
          }

          var gtagItens = [];

          this.$store.state.pedido.itens.forEach(prod => {
            gtagItens.push({
              "item_id": 'produto_' + prod.id,
              "item_name": prod.nome,
              "item_category": prod.grupo_nome,
              "quantity": prod.quantidade,
              "currency": "BRL",
              "price": parseFloat("0" + prod.valor)
            });

            prod.adicionais.forEach(ad => {
              gtagItens.push({
                "item_id": 'adicional_' + ad.adicional_id,
                "item_name": ad.nome,
                "quantity": this.$store.state.produto.quantidade * ad.quantidade,
                "currency": "BRL",
                "price": parseFloat("0" + ad.valor)
              });
            });
          });

          gtag('event', 'purchase', {
            "transaction_id": this.$store.state.empresa.id + '_' + this.numero_pedido,
            "value": (this.forma_entrega == 'ENTREGA' ? this.$store.getters.pedidoTotal : this.$store.getters.pedidoSubtotal),
            "currency": "BRL",
            "items": gtagItens
          });

          this.FazerLogin();

          if(pedido_temporario) return;

          this.pedido_enviado = true;

          try {
            if (this.$store.state.empresa.receber_pedidos_whatsapp == "S")
            this.EnviarParaWhatsApp();
          } catch (error) {
            
          }

          

          var ls = new SecureLS();
          this.$store.state.pedido.itens.forEach(prod => {
            ls.remove('prod' + prod.id);
          });

          Swal.fire({
            title: 'Obrigado!</br>' + this.$store.state.pedido.nome_cliente,
            icon: 'success',
            customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
            onClose: () => {
              if (this.isInstagramOnIOS()) {
                const url = 'https://api.whatsapp.com/send?phone='+ this.$store.state.empresa.whatsapp +'&text=' + encodeURIComponent(this.pedidoEnviadoLinkText);
                window.location.href = url;
              }else{
                this.IrParaPagina();
              }
              // setTimeout(() => {
              // this.IrParaPagina();
              // }, 1000);
            }
          });
        }
      })

    },
    async CadastrarCliente() {
      let telefone = this.telefone.replace(/\D/g, ''); 
      this.isLoading = true;
      await axios.post(this.$store.state.apiUrl + "cliente/cadastrar", {telefone, nome: this.nome_cliente})
      .then(response => {
        this.isLoading = false;
        this.clienteLogado = true;
        SalvarLoginDoClienteNoNavegador(response.data.cliente);
        return response.data.cliente;
      }).catch(error => {
        this.isLoading = false;
        return null;
      });
    },    
    async FazerLogin() {
      let telefone = this.telefone.replace(/\D/g, ''); 
      this.isLoading = true;
      await axios.post(this.$store.state.apiUrl + "cliente/login", {telefone})
      .then(response => {
        this.isLoading = false;
        this.clienteLogado = true;
        SalvarLoginDoClienteNoNavegador(response.data.cliente);
        return response.data.cliente.id;
      }).catch(async error => {
        this.isLoading = false;
        return null;
      });
    },
    IrParaPagina() {
      debugger

      //tratar modulo_entregador
      //verificar se esta ativo
      //se tiver enviar para pagina de status do pedido junto com o html do pedido e o id do pedido
      //
      if(this.$store.state.empresa.modulo_entregador == 'ATIVO' && this.forma_entrega == "ENTREGA"){
        let chave = CryptoJS.MD5(this.numero_pedido).toString();
        Cookies.set(chave, btoa(this.numero_pedido.toString()), { expires: 3 });
        window.open('/' + this.$router.currentRoute.params.empresa + '/pedido/status/' + CryptoJS.MD5(this.numero_pedido).toString(), '_blank');
      }

      if (this.$store.state.url_multilink == '') {
        location.reload();
      } else {
        this.$router.push('/' + this.$router.currentRoute.params.empresa + '/menu' + this.$store.state.url_multilink);
        location.reload();
      }
    },
    cpf_mask(v) {
      return v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
    },
    cep_mask(v) {
      return v.replace(/(\d{5})/g, "\$1-");
    },
    RemoverItem(item) {
      Swal.fire({
        title: 'Aviso',
        text: "Deseja realmente remover " + item.nome,
        icon: 'warning',
        customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          var gtagItens = [];

          gtagItens.push({
            "item_id": 'produto_' + item.id,
            "item_name": item.nome,
            "item_category": item.grupo_nome,
            "quantity": item.quantidade,
            "currency": "BRL",
            "price": parseFloat("0" + item.valor)
          });

          item.adicionais.forEach(ad => {
            gtagItens.push({
              "item_id": 'adicional_' + ad.adicional_id,
              "item_name": ad.nome,
              "quantity": item.quantidade * ad.quantidade,
              "currency": "BRL",
              "price": parseFloat("0" + ad.valor)
            });
          });

          gtag('event', 'remove_from_cart', {"items": gtagItens});

          this.$store.commit('remover_item_pedido', item);
          this.CalcularDesconto(null, this.forma_pagamento);

          this.$store.state.cupom_desconto_valor = 0.00;
          this.AplicarDesconto();

          M.toast({html: "<strong>Item removido do pedido</strong>", displayLength: 4000});

          this.ChegarProdutosSomenteParaRetirada();

          if (this.forma_entrega == "ENTREGA") {
            this.CalcularFreteDebounced(this.endereco.bairro);
          }

        }
      })
    },
    ChangeQtdItem(item, add) {

      if(item.adicionais.length > 0) return;

      if (add && this.$store.state.produto.controlar_estoque == "S") {
        if (item.quantidade >= this.$store.state.produto.quantidade) {
          alert("Limite máximo atingido");
          return false;
        }
      };

      add ? item.quantidade++ : item.quantidade --;

      this.$store.commit('adicionar_item_pedido_carrinho', item);

      this.CalcularDesconto(null, this.forma_pagamento);
      this.$store.state.cupom_desconto_valor = 0.00;
      this.AplicarDesconto();

      this.ChegarProdutosSomenteParaRetirada();

      if (this.forma_entrega == "ENTREGA") {
        this.CalcularFreteDebounced(this.endereco.bairro);
      }

      this.pedidoMinimoEntrega();
    },
    RemoverAdicional(item, adicionalRemover) {

      if (adicionalRemover.obrigatorio == "S") {
        M.toast({html: 'Não é possível excluir um item obrigatório', displayLength: 3000});
        return;
      }

      Swal.fire({
        title: 'Aviso',
        text: "Deseja realmente remover " + adicionalRemover.nome,
        icon: 'warning',
        customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {

          gtag('event', 'remove_from_cart', {
            "items": [
              {
                "item_id": 'adicional_' + adicionalRemover.adicional_id,
                "item_name": adicionalRemover.nome,
                "quantity": item.quantidade * adicionalRemover.quantidade,
                "currency": "BRL",
                "price": parseFloat("0" + adicionalRemover.valor)
              }
            ]
          });

          this.$store.commit('remover_item_adicional_pedido', {item: item, adicional: adicionalRemover});

          Swal.fire({
            title: 'Removido!',
            text: 'Item removido do pedido.',
            icon: 'success',
            customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'}
          }).then((result) => {

            this.$router.push('/' + this.$store.state.empresa_url + '/menu');
            setTimeout(res => {
              this.$router.push("/" + this.$store.state.empresa_url + "/pedido");
            }, 3)
          })

        }
      })
    },
    ObterValorFrete() {
      var valor = (parseFloat(this.$store.state.empresa.taxa_entrega)).toFixed(2);
      if (valor == "0.00") {
        return this.taxa_entrega_v2;
      } else {
        return 'R$ ' + valor;
      }
    },
    PrepararLista() {
      let objList = this.$store.state.pedido.itens;
      objList = JSON.parse(JSON.stringify(objList));

      let uniqueList = [];
      let dupList = [];

      Array.prototype.contains = function (item) {
        let filtered_item = this.filter((i) => {
          return (i.id === item.id) &&
            (item.adicionais && item.adicionais.length == 0) &&
            (item.categorias && item.categorias.length == 0) &&
            (i.observacao_cliente == item.observacao_cliente);
        });
        return !!filtered_item.length;

      }

      // function contains(list, item) {
      //   let filtered_item = list.filter((i) => {
      //     return i.id === item.id && item.adicionais.length == 0 && item.categorias.length == 0 && i.observacao_cliente == item.observacao_cliente
      //   });
      //   return !!filtered_item.length;
      // }

      function pushToUniqueList(item) {
        uniqueList.push(item);
      }

      function pushToDuplicateList(item) {
        dupList.push(item);
      }

      for (let i = 0; i < objList.length; i++) {
        if (uniqueList.contains(objList[i])) {
          pushToDuplicateList(objList[i]);
        } else {
          pushToUniqueList(objList[i]);
        }
      }

      /// Nova verificação
      var listaCondensadaB = [];
      for (let i = 0; i < objList.length; i++) {
        if (dupList.contains(objList[i])) {
          var res = objList[i];
          listaCondensadaB[res.id] = res.quantidade + (listaCondensadaB[res.id] ? listaCondensadaB[res.id] : 0);
          objList[i].quantidade = res.quantidade + (listaCondensadaB[res.id] ? listaCondensadaB[res.id] : 0);
          const index = objList.indexOf(i);
          if (index > -1) {
            objList.splice(index, 1);
          }
        }
      }

      let objListT = objList;

      let uniqueListT = [];
      let dupListT = [];

      Array.prototype.containsT = function (item) {
        let filtered_item = this.filter((i) => {
          return (i.id === item.id) &&
            (item.adicionais && item.adicionais.length == 0) &&
            (item.categorias && item.categorias.length == 0) &&
            (i.observacao_cliente == item.observacao_cliente);
        });
        return !!filtered_item.length;
      }

      function containsT(list, item) {
        let filtered_item = list.filter((i) => {
          return i.id === item.id && item.adicionais.length == 0 && item.categorias.length == 0 && i.observacao_cliente == item.observacao_cliente
        });
        return !!filtered_item.length;
      }

      function pushToUniqueListT(item) {
        if (!uniqueListT.containsT(item)) uniqueListT.push(item);
      }

      function pushToDuplicateListT(item) {
        if (!dupListT.containsT(item)) dupListT.push(item);
      }

      for (let i = 0; i < objListT.length; i++) {
        if (uniqueListT.containsT(objListT[i])) {
          pushToDuplicateListT(objListT[i]);
        } else {
          pushToUniqueListT(objListT[i]);
        }
      }

      return uniqueListT;

    }, //forma_pagamento
    FormatarFormaPagamento(forma) {
      let formaPagemento = forma;
      switch (formaPagemento) {
        case 'VALE_ALIMENTACAO':
          formaPagemento = 'Vale Alimentação'
          break;
        case 'VALE_REFEICAO':
          formaPagemento = 'Vale Refeição'
          break;
        case 'MERCADOPAGO_PIX':
          formaPagemento = 'PIX Online'
          break;
        case 'MERCADOPAGO_CARTAO':
          formaPagemento = this.mercadopago_pagamento_cartao_descricao_forma_pagamento;
          break;
        case 'PAGHIPER_PIX':
          formaPagemento = 'PIX Online'
          break;
        case 'SOFTEXPRESS_CARTAO':
          formaPagemento = 'Cartão de Crédito - Final: ***' + $('#softwareExpressNumero').val().slice(-4)
          break;
      }
      return formaPagemento;
    },
    ObservacaoPagamento(opcao) {
      var desconto = this.$store.state.empresa && this.$store.state.empresa.desconto ? this.$store.state.empresa.desconto : {};
      let observacao = '';
      
      switch (opcao) {
        case "DINHEIRO": observacao = desconto["DINHEIRO"] && desconto["DINHEIRO"].observacao ? desconto["DINHEIRO"].observacao : ''; break;
        case "DEBITO": observacao = desconto["DEBITO"] && desconto["DEBITO"].observacao ? desconto["DEBITO"].observacao : ''; break;
        case "CREDITO": observacao = desconto["CREDITO"] && desconto["CREDITO"].observacao ? desconto["CREDITO"].observacao : ''; break;
        case "TRANSFERENCIA": observacao = desconto["TRANSFERENCIA"] && desconto["TRANSFERENCIA"].observacao ? desconto["TRANSFERENCIA"].observacao : ''; break;
        case "PIX": observacao = desconto["PIX"] && desconto["PIX"].observacao ? desconto["PIX"].observacao : ''; break;
        case "VALE_ALIMENTACAO": observacao = desconto["VALE_ALIMENTACAO"] && desconto["VALE_ALIMENTACAO"].observacao ? desconto["VALE_ALIMENTACAO"].observacao : ''; break;
        case "VALE_REFEICAO": observacao = desconto["VALE_REFEICAO"] && desconto["VALE_REFEICAO"].observacao ? desconto["VALE_REFEICAO"].observacao : ''; break;
        default: observacao = '';
      }

      return observacao ? `(${observacao})` : '';
    },
    CalcularDesconto(e = null, opcao = "DINHEIRO") {
      var desconto = this.$store.state.empresa.desconto;
      var total = parseFloat(this.$store.getters.getValorTotalPedido);
      var total_qual_desconto = total;
      this.valor_desconto = 0.0;
      this.taxa_retorno = 0.0;
      this.forma_pagamento = opcao;
      switch (opcao) {
        case "DINHEIRO":  //adelson
          this.taxa_retorno = (this.forma_entrega == 'ENTREGA' && this.precisa_troco) ? this.$store.state.empresa.taxa_retorno_troco : 0;
          const descontoDinheiro = desconto && desconto["DINHEIRO"];
          if (
            descontoDinheiro &&
            descontoDinheiro["ativo"] &&
            descontoDinheiro["ativo"] == "S" &&
            descontoDinheiro["forma_desconto"] &&
            descontoDinheiro["forma_desconto"] != ""
          ) {
            switch (desconto["DINHEIRO"]["forma_desconto"]) {
              case "PRECO":

                var des_valor = parseFloat(
                  desconto["DINHEIRO"]["valor"]
                ).toFixed(2);
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                if (this.forma_entrega == "ENTREGA") {
                  this.CalcularFreteDebounced(this.endereco.bairro);
                }
                if (this.taxa_retorno > 0) {
                  M.toast({
                    html: "Taxa de retorno do troco R$" + this.taxa_retorno + " aplicada.",
                    displayLength: 3000,
                  });
                }                
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["DINHEIRO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "DEBITO":
        this.taxa_retorno = this.forma_entrega == 'ENTREGA' ? this.$store.state.empresa.taxa_retorno_maquina : 0;
          if (
            desconto["DEBITO"]["ativo"] &&
            desconto["DEBITO"]["ativo"] == "S" &&
            desconto["DEBITO"]["forma_desconto"] &&
            desconto["DEBITO"]["forma_desconto"] != ""
          ) {
            switch (desconto["DEBITO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(desconto["DEBITO"]["valor"]).toFixed(
                  2
                );
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["DEBITO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "CREDITO":
        this.taxa_retorno = this.forma_entrega == 'ENTREGA' ? this.$store.state.empresa.taxa_retorno_maquina : 0;
          if (
            desconto["CREDITO"]["ativo"] &&
            desconto["CREDITO"]["ativo"] == "S" &&
            desconto["CREDITO"]["forma_desconto"] &&
            desconto["CREDITO"]["forma_desconto"] != ""
          ) {
            switch (desconto["CREDITO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(
                  desconto["CREDITO"]["valor"]
                ).toFixed(2);
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["CREDITO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "TRANSFERENCIA":
          if (
            desconto["TRANSFERENCIA"]["ativo"] &&
            desconto["TRANSFERENCIA"]["ativo"] == "S" &&
            desconto["TRANSFERENCIA"]["forma_desconto"] &&
            desconto["TRANSFERENCIA"]["forma_desconto"] != ""
          ) {
            switch (desconto["TRANSFERENCIA"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(
                  desconto["TRANSFERENCIA"]["valor"]
                ).toFixed(2);
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) *
                  desconto["TRANSFERENCIA"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "PIX":
          if (
            desconto["PIX"]["ativo"] &&
            desconto["PIX"]["ativo"] == "S" &&
            desconto["PIX"]["forma_desconto"] &&
            desconto["PIX"]["forma_desconto"] != ""
          ) {
            switch (desconto["PIX"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(desconto["PIX"]["valor"]).toFixed(
                  2
                );
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["PIX"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;
        case "VALE_ALIMENTACAO":
          if (
            desconto["VALEALIMENTACAO"]["ativo"] &&
            desconto["VALEALIMENTACAO"]["ativo"] == "S" &&
            desconto["VALEALIMENTACAO"]["forma_desconto"] &&
            desconto["VALEALIMENTACAO"]["forma_desconto"] != ""
          ) {
            switch (desconto["VALEALIMENTACAO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(desconto["VALEALIMENTACAO"]["valor"]).toFixed(
                  2
                );
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["VALEALIMENTACAO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
 this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;
        case "VALE_REFEICAO":
          if (
            desconto["VALEREFEICAO"]["ativo"] &&
            desconto["VALEREFEICAO"]["ativo"] == "S" &&
            desconto["VALEREFEICAO"]["forma_desconto"] &&
            desconto["VALEREFEICAO"]["forma_desconto"] != ""
          ) {
            switch (desconto["VALEREFEICAO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(desconto["VALEREFEICAO"]["valor"]).toFixed(
                  2
                );
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["VALEREFEICAO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;
        default:
          return 0.0;

      }

      this.ObterValorTotalAtualizadoDoPedido();

      if (this.forma_entrega == "ENTREGA") {
        this.CalcularFreteDebounced(this.endereco.bairro);
      }

    },
    EnviarParaWhatsApp() {
      var pedidoStore = this.$store.state.pedido;
      pedidoStore.itens = this.PrepararLista();
      pedidoStore.conta_bancaria = this.conta_bancaria

      let pedido = new WMCompose();

      var strNumPedido = this.numero_pedido.toString();
      var pad = "00000"
      strNumPedido = pad.substring(0, pad.length - strNumPedido.length) + strNumPedido

      pedido.writeText("*Pedido #" + strNumPedido + "* - _" + this.$store.state.empresa.nome + "_");

      pedido.writeText("------------------------------------", 1);
      pedidoStore.itens.forEach(item => {
        pedido.writeText("*" + item.quantidade + 'x ' + item.nome + "* - R$ " + (item.quantidade * parseFloat(item.valor)).toFixed(2), 1);

        if (this.$store.state.empresa.mostrar_categoria_wpp == "S") {
          item.categorias.forEach(categoria => {
            pedido.writeText("  *" + categoria.descricao + "*", 1);
            categoria.adicionais.forEach(adicional => {
              pedido.writeText("    " + (adicional.quantidade * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * adicional.quantidade * item.quantidade).toFixed(2)), 1);
            });
          });
        } else {
          item.adicionais.forEach(adicional => {
            pedido.writeText("    " + (adicional.quantidade * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * adicional.quantidade * item.quantidade).toFixed(2)), 1);
          });
        }

        if (item.observacao_cliente && item.observacao_cliente !== '.')
          pedido.writeText("*Obs:* _" + item.observacao_cliente + "_", 1);
      });

      pedido.writeText("------------------------------------", 1);

      pedido.writeText("*Subtotal: R$ " + this.$store.getters.pedidoSubtotal.toFixed(2) + "*", 1, 1);

      if (this.$store.state.cupom_desconto_valor > 0)
        pedido.writeText("*Cupom de Desconto: R$ " + parseFloat(this.$store.state.cupom_desconto_valor).toFixed(2) + "*", 1, 1);

      if (this.valor_desconto > 0){
        pedido.writeText("*Desconto: R$ " + parseFloat(this.valor_desconto).toFixed(2) + "*", 1, 1);
      }else if(pedidoStore.valor_desconto < 0){
        pedido.writeText("*Acréscimo: R$ " + parseFloat(this.valor_desconto *-1).toFixed(2) + "*", 1, 1);
      }

      if (this.forma_entrega == "ENTREGA")
        pedido.writeText("*Taxa de entrega: " + this.ObterValorFrete() + "*", 1, 1);

      if (this.taxa_retorno > 0 && this.forma_pagamento != "DINHEIRO") {
        pedido.writeText("*Taxa retorno maquininha: " + parseFloat(this.taxa_retorno).toFixed(2) + "*", 1, 1)
      }

      if (this.taxa_retorno > 0 && this.forma_pagamento === "DINHEIRO") {
        pedido.writeText("*Taxa retorno troco: " + parseFloat(this.taxa_retorno).toFixed(2) + "*", 1, 1)
      }
//this.forma_entrega == 'ENTREGA' ? this.$store.getters.pedidoTotal : this.$store.getters.pedidoSubtotal
      //pedido.writeText("*Total: R$ " + (this.$store.getters.pedidoTotal).toFixed(2)+"*", 1)
      pedido.writeText(
        "*Total: R$ " + 
        (
          parseFloat(this.$store.getters.getValorTotalPedido) +
          parseFloat(this.taxa_retorno) -
          parseFloat(this.valor_desconto) +
          (this.forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0)
        ).toFixed(2) + 
        "*", 
        1
      );

      pedido.writeText("------------------------------------", 1);

      if (this.$store.state.empresa.habilitar_entrega == 'S') {
        pedido.writeText("*Como deseja receber o pedido?*", 1);
        pedido.writeText("```" + pedidoStore.forma_entrega + "```", 1);

        if (this.forma_entrega == 'ENTREGA' && this.somenteBairro == 'N') {
          pedido.writeText("*Endereço de Entrega*", 2);
          pedido.writeText("*" + pedidoStore.entrega_endereco + ", " + (pedidoStore.entrega_numero || "S/N") + (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "*", 1);
          pedido.writeText("*" + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "*", 1);
          if (pedidoStore.entrega_cep)
            pedido.writeText("*" + this.cep_mask(pedidoStore.entrega_cep) + "*", 1);
        }

        if (this.forma_entrega == 'ENTREGA' && this.somenteBairro == 'S') {
          pedido.writeText("*Endereço de Entrega*", 2);
          pedido.writeText("*" + pedidoStore.entrega_endereco + ", " +  (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "*", 1);
          pedido.writeText("*" + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "*", 1);
          if (pedidoStore.entrega_cep)
            pedido.writeText("*" + this.cep_mask(pedidoStore.entrega_cep) + "*", 1);
        }
      }

      pedido.writeText("*Forma de Pagamento:* " + " " + this.FormatarFormaPagamento(pedidoStore.forma_pagamento), 2);
      // pedido.writeText("*"+this.FormatarFormaPagamento(pedidoStore.forma_pagamento)+"*", 1);//"```" + + "```"

      if (pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("*Link de Pagamento*", 2);
        pedido.writeText(this.link_pagamento, 1);

        pedido.writeText("*Visualizar Status do Pagamento*", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento, 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        // pedido.writeText("*Chave*", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "*Chave Aleatória*";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "*Celular*";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "*CPF/CNPJ*";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "*E-mail*";
            break;
        }

        // pedido.writeText("```" + forma_pagamento_texto_amigavel + "```"+": "+this.$store.state.empresa.pagamento_pix_chave , 1);
        pedido.writeText("*Chave*" + " " + forma_pagamento_texto_amigavel + ": *" + this.$store.state.empresa.pagamento_pix_chave + "*", 1);
        pedido.writeText("*Beneficiário*: " + this.$store.state.empresa.pagamento_pix_nome_conta, 1);

        // pedido.writeText("*PIX - Chave Pagamento:*", 1);
        // pedido.writeText("```" + this.$store.state.empresa.pagamento_pix_chave + "```", 1);
      }

      if (pedidoStore.precisa_troco == "S") {
        pedido.writeText("*Precisa de troco?*", 2);
        pedido.writeText("Sim, para R$" + pedidoStore.troco_para_quanto, 1);
      }


      if (pedidoStore.conta_bancaria) {
        if (((pedidoStore.conta_bancaria.ativo === "S") && (pedidoStore.forma_pagamento === "TRANSFERENCIA"))) {
          pedido.writeText("*Conta Selecionada*", 2);
          pedido.writeText("Banco: " + pedidoStore.conta_bancaria.banco.nome + " (" + pedidoStore.conta_bancaria.banco.codigo + ")", 1);
          pedido.writeText("Agência: " + pedidoStore.conta_bancaria.agencia, 1);
          pedido.writeText("Conta: " + pedidoStore.conta_bancaria.conta, 1);
          pedido.writeText("Tipo Conta: " + pedidoStore.conta_bancaria.tipo_conta, 1);
          pedido.writeText("Titular: " + pedidoStore.conta_bancaria.nome, 1);
          pedido.writeText("CPF/CNPJ: " + pedidoStore.conta_bancaria.cpf_cnpj, 1);
          if (pedidoStore.conta_bancaria.informacoes_adicionais) {
            pedido.writeText("Observações: " + pedidoStore.conta_bancaria.informacoes_adicionais, 1);
          }
        }
      }

      if (this.bandeira_vale_alimentacao) {
        pedido.writeText("*Bandeira Selecionada*", 2);
        pedido.writeText("" + this.bandeira_vale_alimentacao.descricao, 1);
      }

      if (this.bandeira_vale_refeicao) {
        pedido.writeText("*Bandeira Selecionada*", 2);
        pedido.writeText("" + this.bandeira_vale_refeicao.descricao, 1);
      }


      pedido.writeText("*Cliente:* " + pedidoStore.nome_cliente, 2);
      pedido.writeText("*Telefone:* " + pedidoStore.telefone, 1);
      if (this.cpf_nota)
        pedido.writeText("*CPF:* " + this.cpf_mask(pedidoStore.cpf), 1);

      if (this.$store.state.empresa.usa_agendamento == 'S') {
        pedido.writeText("*Agendado?:* " + (pedidoStore.agendado == "S" ? "Sim" : "Não"), 2);
        if (pedidoStore.agendado == "S")
          pedido.writeText("*Agendado para:* " + pedidoStore.data_agendamento + ' ' + pedidoStore.hora_agendamento, 1);
      }

      pedido.writeText("*Tempo médio de entrega:* " + this.$store.state.empresa.tempo_medio_entrega, 2);

      if (pedidoStore.observacoes != "") {
        pedido.writeText("*" + this.$store.state.empresa.label_observacoes + ":* " + pedidoStore.observacoes, 2);
      }

      var horaAtual = new Date();
      var strHoraAtual = moment().format('HH:mm');
      var strDataAtual = moment().format('DD/MM/YYYY');

      if (this.$router.currentRoute.query.src)
        pedido.writeText("_via " + this.$router.currentRoute.query.src + "_", 2);

      pedido.writeText("_Pedido gerado por Sirrus Sistemas em " + strDataAtual + " às " + strHoraAtual + "_", 2);

      if (this.isInstagramOnIOS()) {
          this.pedidoEnviadoLinkText = pedido.getText();
      } else {
          WMSend(this.$store.state.empresa.whatsapp, pedido.getText());
      }

    },
    isInstagramOnIOS() {
        // Verifica se o user agent contém informações relacionadas ao Instagram
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isInstagram = /Instagram/.test(userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

        return isInstagram && isIOS;
    },
    ObterHTMLdoPedido() {
      var pedidoStore = this.$store.state.pedido;
      pedidoStore.itens = this.PrepararLista();
      pedidoStore.conta_bancaria = this.conta_bancaria

      let pedido = new WMCompose();

      pedido.writeText("------------------------------------<br>", 1);
      pedidoStore.itens.forEach(item => {
        pedido.writeText("<strong>" + item.quantidade + 'x ' + item.nome + "</strong> - R$ " + (item.quantidade * parseFloat(item.valor)).toFixed(2) + "<br>", 1);

        if (this.$store.state.empresa.mostrar_categoria_wpp == "S") {
          item.categorias.forEach(categoria => {
            pedido.writeText("  <strong>" + categoria.descricao + "</strong><br>", 1);
            categoria.adicionais.forEach(adicional => {
              pedido.writeText("    " + (adicional.quantidade * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * adicional.quantidade * item.quantidade).toFixed(2)) + "<br>", 1);
            });
          });
        } else {
          item.adicionais.forEach(adicional => {
            pedido.writeText("    " + (adicional.quantidade * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * adicional.quantidade * item.quantidade).toFixed(2)) + "<br>", 1);
          });
        }

        if (item.observacao_cliente && item.observacao_cliente !== '.')
          pedido.writeText("<strong>Obs:</strong> <i>" + item.observacao_cliente + "</i><br>", 1);
      });

      pedido.writeText("------------------------------------<br>", 1);

      pedido.writeText("<strong>Subtotal: R$ " + this.$store.getters.pedidoSubtotal.toFixed(2) + "</strong><br>", 1, 1);

      if (this.forma_entrega == "ENTREGA")
        pedido.writeText("<br><strong>Taxa de entrega:" + this.ObterValorFrete() + "</strong> <br>", 1, 1);

      if (this.taxa_retorno > 0 && this.forma_pagamento != "DINHEIRO") {
        pedido.writeText("<br><strong>Taxa retorno maquininha: " + parseFloat(this.taxa_retorno).toFixed(2) + "</strong> <br>", 1, 1)
      }

      if (this.taxa_retorno > 0 && this.forma_pagamento === "DINHEIRO") {
        pedido.writeText("<br><strong>Taxa retorno troco: " + parseFloat(this.taxa_retorno).toFixed(2) + "</strong> <br>", 1, 1)
      }

      if (this.$store.state.cupom_desconto_valor > 0)
        pedido.writeText("<strong>Cupom de Desconto:</strong> R$ " + parseFloat(this.$store.state.cupom_desconto_valor).toFixed(2) + "<br>", 1, 1);

      if (this.valor_desconto > 0){
        pedido.writeText("<strong>Desconto:</strong> R$ " + parseFloat(this.valor_desconto).toFixed(2) + "<br>", 1, 1);
      }else if(this.valor_desconto < 0){
        pedido.writeText("<strong>Acréscimo:</strong> R$ " + parseFloat(this.valor_desconto *-1).toFixed(2) + "<br>", 1, 1);
      }
        
      pedido.writeText("<strong>Total: R$ " + (this.forma_entrega == 'ENTREGA' ? (this.$store.getters.pedidoTotal + parseFloat(this.taxa_retorno)) - this.valor_desconto : this.$store.getters.pedidoSubtotal - this.valor_desconto).toFixed(2) + "</strong><br>", 1)
      pedido.writeText("------------------------------------<br>", 1);

      if (this.$store.state.empresa.habilitar_entrega == 'S') {
        pedido.writeText("<strong>Como deseja receber o pedido?</strong><br>", 1);
        pedido.writeText("<span>" + pedidoStore.forma_entrega + "</span><br>", 1);

        if (this.forma_entrega == 'ENTREGA' && this.somenteBairro == 'N') {
          pedido.writeText("<strong>Endereço de Entrega</strong><br>", 2);
          pedido.writeText("<strong>" + pedidoStore.entrega_endereco + ", " + (pedidoStore.entrega_numero || "S/N") + (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "</strong><br>", 1);
          pedido.writeText("<strong>" + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "</strong><br>", 1);
          if (pedidoStore.entrega_cep)
            pedido.writeText("<strong>" + this.cep_mask(pedidoStore.entrega_cep) + "</strong><br>", 1);
        }

        if (this.forma_entrega == 'ENTREGA' && this.somenteBairro == 'S') {
          pedido.writeText("<strong>Endereço de Entrega</strong><br>", 2);
          pedido.writeText("<strong>" + pedidoStore.entrega_endereco + ", " +  (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "</strong><br>", 1);
          pedido.writeText("<strong>" + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "</strong><br>", 1);
          if (pedidoStore.entrega_cep)
            pedido.writeText("<strong>" + this.cep_mask(pedidoStore.entrega_cep) + "</strong><br>", 1);
        }
      }

      pedido.writeText("<br><strong>Forma de Pagamento</strong><br>", 2);
      pedido.writeText("<span><strong>" + this.FormatarFormaPagamento(pedidoStore.forma_pagamento) + "</strong></span><br>", 1);

      if (pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("<strong>Link de Pagamento</strong><br>", 2);
        pedido.writeText(this.link_pagamento + "<br>", 1);

        pedido.writeText("<strong>Visualizar Status do Pagamento</strong><br>", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento + "<br>", 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        pedido.writeText("<br><strong>PIX - Tipo:</strong><br>", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "Chave Aleatória";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "Celular";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "CPF/CNPJ";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "E-mail";
            break;
        }

        pedido.writeText("<span>" + forma_pagamento_texto_amigavel + "</span><br>", 1);

        pedido.writeText("<strong>PIX - Chave Pagamento:</strong><br>", 1);
        pedido.writeText("<span>" + this.$store.state.empresa.pagamento_pix_chave + "</span><br>", 1);
      }


      if (pedidoStore.conta_bancaria) {
        if (((pedidoStore.conta_bancaria.ativo === "S") && (pedidoStore.forma_pagamento === "TRANSFERENCIA"))) {
          pedido.writeText("<strong>Conta Selecionada</strong><br>", 2);
          pedido.writeText("Banco: " + pedidoStore.conta_bancaria.banco.nome + " (" + pedidoStore.conta_bancaria.banco.codigo + ")" + "<br>", 1);
          pedido.writeText("Agência: " + pedidoStore.conta_bancaria.agencia + "<br>", 1);
          pedido.writeText("Conta: " + pedidoStore.conta_bancaria.conta + "<br>", 1);
          pedido.writeText("Tipo Conta: " + pedidoStore.conta_bancaria.tipo_conta + "<br>", 1);
          pedido.writeText("Titular: " + pedidoStore.conta_bancaria.nome + "<br>", 1);
          pedido.writeText("CPF/CNPJ: " + pedidoStore.conta_bancaria.cpf_cnpj + "<br>", 1);
          if (pedidoStore.conta_bancaria.informacoes_adicionais) {
            pedido.writeText("Observações: " + pedidoStore.conta_bancaria.informacoes_adicionais + "<br>", 1);
          }
        }
      }

      if (this.bandeira_vale_alimentacao) {
        pedido.writeText("<strong>Bandeira Selecionada</strong><br>", 2);
        pedido.writeText("" + this.bandeira_vale_alimentacao.descricao + "<br>", 1);
      }

      if (this.bandeira_vale_refeicao) {
        pedido.writeText("<strong>Bandeira Selecionada</strong><br>", 2);
        pedido.writeText("" + this.bandeira_vale_refeicao.descricao + "<br>", 1);
      }

      pedido.writeText("<strong>Cliente:</strong> " + pedidoStore.nome_cliente + "<br><br>", 2);
      pedido.writeText("<strong>Telefone:</strong> " + pedidoStore.telefone + "<br>", 1);
      if (this.cpf_nota)
        pedido.writeText("<strong>CPF:</strong> " + this.cpf_mask(pedidoStore.cpf) + "<br>", 1);

      if (this.$store.state.empresa.usa_agendamento == 'S') {
        pedido.writeText("<strong>Agendado?:</strong> " + (pedidoStore.agendado == "S" ? "Sim" : "Não"), 2);
        if (pedidoStore.agendado == "S")
          pedido.writeText("*Agendado para:* " + pedidoStore.data_agendamento + ' ' + pedidoStore.hora_agendamento, 1);
      }

      if (pedidoStore.observacoes != "")
        pedido.writeText(this.$store.state.empresa.label_observacoes + ": " + pedidoStore.observacoes);

      pedido.writeText("<strong>Tempo médio de entrega:</strong> " + this.$store.state.empresa.tempo_medio_entrega + "<br><br>", 2);

      // console.log(pedido.getText());
      return pedido.getText();

    },
    formatarPais(pais) {
      return pais.nome;
    },    
    pedidoMinimoEntrega () {
      let disabled = (!this.$store.state.empresa.valor_minimo_entrega > 0) ? false : this.$store.getters.pedidoSubtotal < this.$store.state.empresa.valor_minimo_entrega;
      if(disabled) this.forma_entrega = 'RETIRADA';
      this.EntregaisDisabled = disabled;
      return disabled;
    },
    initializePaisesTelefone() {
      const ls = new SecureLS();
      const dadosCliente = ls.get('dados_cliente');
      // console.log('dadosCliente', dadosCliente);
      
      if (this.paisesTelefoneList && this.paisesTelefoneList.length > 0) {
        // 1. Configura o país selecionado
        if (dadosCliente && dadosCliente.pais_telefone) {
          const paisSalvo = this.paisesTelefoneList.find(p => p.codigo_area === dadosCliente.pais_telefone);
          if (paisSalvo) {
            this.pais_selecionado_obj = paisSalvo;
          } else {
            this.pais_selecionado_obj = this.paisesTelefoneList[0];
          }
        } else {
          this.pais_selecionado_obj = this.paisesTelefoneList[0];
        }

        // 2. Configura o telefone apenas se existir nos dados salvos
        if (dadosCliente && dadosCliente.telefone) {
          this.telefone = dadosCliente.telefone;
        }
      }
    },
    handlePaisChange(event) {
      if (!this.pais_selecionado_obj) return;
      
      if (this.pais_selecionado_obj.codigo_area === 'outros') {
        this.codigoAreaCustom = true;
        this.pais_selecionado_obj = {codigo_area: ''};
        this.telefone = '';
      } else {
        this.codigoAreaCustom = false;
        if (!this.telefone) {
          this.telefone = this.pais_selecionado_obj.codigo_area;
        }
      }
    },
    validarCodigoArea(event) {
      let valor = event.target.value;
      // Remove todos os caracteres exceto números e +
      valor = valor.replace(/[^\d+]/g, '');
      // Garante que só tem um +
      valor = valor.replace(/\+{2,}/g, '+');
      // Garante que o + só aparece no início
      valor = valor.replace(/(?!^)\+/g, '');
      // Se não começar com +, adiciona
      if (!valor.startsWith('+')) {
        valor = '+' + valor;
      }
      this.pais_selecionado_obj.codigo_area = valor;
      this.telefone = valor;
    },
    switchToPaisSelection() {
      this.codigoAreaCustom = false;
      // Reset to a default or the first in the list
      if (this.paisesTelefoneList && this.paisesTelefoneList.length > 0) {
        this.pais_selecionado_obj = this.paisesTelefoneList[0];
      } else {
        this.pais_selecionado_obj = {codigo_area: "+55"}; // Fallback default
      }
      this.telefone = this.pais_selecionado_obj.codigo_area;
      // Re-initialize the select component if needed (Materialize specific)
      this.$nextTick(() => {
        $('select').formSelect();
      });
    },
    validarCPF(cpf) {
      if (!cpf) return false;
      
      // Remove non-digits
      cpf = cpf.replace(/[^\d]/g, '');
      
      // Check length
      if (cpf.length !== 11) return false;
      
      // Check for all same digits
      if (/^(\d)\1{10}$/.test(cpf)) return false;
      
      // Validate digits
      let sum = 0;
      let remainder;
      
      for (let i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i-1, i)) * (11 - i);
      }
      
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.substring(9, 10))) return false;
      
      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum = sum + parseInt(cpf.substring(i-1, i)) * (12 - i);
      }
      
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.substring(10, 11))) return false;
      
      return true;
    },
    checkCPFFieldVisibility() {
      const cpfField = document.getElementById('cpf');
      console.log('Debug - CPF Field Check:');
      console.log('Field element:', cpfField);
      if (cpfField) {
        const styles = window.getComputedStyle(cpfField);
        console.log('Display:', styles.display);
        console.log('Visibility:', styles.visibility);
        console.log('Opacity:', styles.opacity);
        console.log('Position:', styles.position);
        console.log('Height:', styles.height);
        console.log('Width:', styles.width);
        console.log('Parent display:', window.getComputedStyle(cpfField.parentElement).display);
      }
    },
    logFocus() {
      console.log('Debug - CPF field focused');
    },
    logBlur() {
      console.log('Debug - CPF field lost focus');
    },
    async mounted() {
      // Os bairros já estão disponíveis em this.$store.state.empresa.tarifas_entrega_bairro
      this.bairros = (this.$store.state.empresa && this.$store.state.empresa.tarifas_entrega_bairro) || [];
      
      // Se só houver um país, seleciona automaticamente
      await this.$nextTick();
      if (this.paisesDisponiveis.length === 1) {
        this.pais_selecionado = this.paisesDisponiveis[0].id;
      }

      // Reinicializa o select do Materialize
      this.$nextTick(() => {
        $('select').formSelect();
      });
    },
    onPaisChange() {
      // Limpa as seleções quando o país muda
      this.bairro_id = '';
      this.endereco.bairro = '';
      
      // Reinicializa o select do Materialize
      this.$nextTick(() => {
        $('select').formSelect();
      });
    },
  },
  computed: {
    paisesDisponiveis() {
      console.log('Calculando países disponíveis, bairros:', this.bairros);
      
      // Extrai países únicos dos bairros
      const paises = this.bairros.reduce((acc, bairro) => {
        if (!acc.find(p => p.id === bairro.pais_id)) {
          acc.push({
            id: bairro.pais_id,
            nome: bairro.pais_nome,
            codigo: bairro.pais_codigo
          });
        }
        return acc;
      }, []);
      
      return paises.sort((a, b) => a.nome.localeCompare(b.nome));
    },
    bairrosFiltrados() {
      if (!this.pais_selecionado || !this.bairros) {
        return [];
      }
      return this.bairros.filter(bairro => Number(bairro.pais_id) === Number(this.pais_selecionado));
    },
    phoneMask() {
      if (this.codigoAreaCustom) {
        return [];
      }
      const codigo_area = this.pais_selecionado_obj ? this.pais_selecionado_obj.codigo_area : null;
      if (codigo_area === '+55') {
        return ['+55 (##) ####-####', '+55 (##) #####-####'];
      }
      if (codigo_area === '+595') {
        return ['+595 (###) ###-####'];
      }
      if(codigo_area){
          return [codigo_area + ' ##################'];
      }
      return [];
    },
    isTelefoneValido() {
      if (this.codigoAreaCustom) {
        return this.telefone.length >= 7;
      }
      const codigo_area = this.pais_selecionado_obj ? this.pais_selecionado_obj.codigo_area : null;
      if (codigo_area === '+55') {
        return this.telefone.length >= 17; // +55 (XX) XXXXX-XXXX
      }
      if (codigo_area === '+595') {
        return this.telefone.length === 18; // +595 (XXX) XXX-XXX
      }
      return this.telefone.length >= 7;
    }
  },
  watch: {
    '$store.state.empresa': {
      async handler(newEmpresa) {
        if (newEmpresa && newEmpresa.tarifas_entrega_bairro) {
          this.bairros = newEmpresa.tarifas_entrega_bairro;
          
          await this.$nextTick();
          console.log('paisesDisponiveis', this.paisesDisponiveis);
          // Se só houver um país, seleciona automaticamente
          if (this.paisesDisponiveis.length === 1 && !this.pais_selecionado) {
            this.pais_selecionado = this.paisesDisponiveis[0].id;
          }
          
          this.$nextTick(() => {
            $('select').formSelect();
          });
        }
      },
      deep: true
    },
    pais_selecionado_obj: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.SalvarDados();
        }
      },
      deep: true
    },
    cpf_nota(newVal) {
      if (!newVal) {
        this.cpf = '';
      }
    },
    bairro_id(newVal) {
      if (newVal) {
        const bairroSelecionado = this.bairros.find(b => b.bairro_id === newVal);
        if (bairroSelecionado) {
          this.endereco.cidade_nome = bairroSelecionado.cidade;
          this.endereco.uf = bairroSelecionado.uf;
          this.endereco.bairro = bairroSelecionado.bairro;
        }
      }
    }
  }
}

</script>

<style scoped>
.btn {
  height: 20px;
  line-height: 13px;
  font-size: 11px;
}

td, th {
  padding: 3px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}

.bloco {
  margin: 10px auto;
}

.content-e {
  text-align: center;
}

.inner-e {
  display: inline-block;
}

.tb.itens {
  border-bottom: 1px solid;
}

.tb.itens.lista {
  padding: 4px 10px;
}

.btn-enviar {
  width: 100%;
  padding: 0 8px;
}

.btn-enviar > span {
  margin-right: 12px;
}

.row .col.s4 {
  margin-left: 0px;
}

.errspan {
  float: left;
  margin-right: 8px;
  margin-top: -35px;
  position: relative;
  z-index: 2;
  color: rgb(8, 110, 61);
}

.div-add-produto {
  border: 1px solid gray;
  padding: 3px;
  border-radius: 8px;
  justify-content: center;
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
}

.btn-add-prod {
  color: green;
}

.btn-add-prod-disable {
  color: rgb(146, 143, 143);
}


.btn-remove-prod {
  color: red;
}

.btn-delete-prod {
  color: rgb(116, 111, 111);
}

.text-qtd {
  margin-left: 10px;
  margin-right: 10px;
  font-size: larger;
  font-weight: bold;
}
 #form-checkout {
   display: flex;
   flex-direction: column;
   max-width: 600px;
 }

.containermp {
  height: 18px;
  display: inline-block;
  border: 1px solid rgb(118, 118, 118);
  border-radius: 2px;
  padding: 1px 2px;
}

.cor-verde-bg {
  background-color: #4CAF50; /* Verde mais suave */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cor-vermelho-bg {
  background-color: #F44336; /* Vermelho mais suave */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cor-verde-bg:hover {
  background-color: #45a049; /* Verde mais escuro ao passar o mouse */
}

.cor-vermelho-bg:hover {
  background-color: #e53935; /* Vermelho mais escuro ao passar o mouse */
}

</style>



// WEBPACK FOOTER //
// src/components/Paginas/Pedido.vue